<template>
  <div v-dragWhole class="set-pathAnim" v-show="isShow && !setFreePath" :style="setPathAnimStyle">
    <!-- 角度显示部分 -->
    <div
      v-show="sprite && dataAction === 'spin'"
      class="rotate-info"
      :style="rotateStyle"
    >{{rotateInfo.deg}}</div>
    <!-- 当前元素的位置和帮助部分 -->
    <div class="current" :style="currentStyle">
      <div class="content" v-html="contentHTML" ref="currentContent"></div>
    </div>
    <div
      :class="{'current-help': true, active: selectWhich === 'current'}"
      data-action="current-move"
      :style="currentHandStyle"
      @dblclick.stop="emitText"
      ref="currentMoveRef"
    >
      <div
        :class="'op-handle-point op-handle-' + point.action"
        v-for="point in currentPoint"
        :data-id="sprite ? sprite.id : ''"
        :data-action="point.action"
        :style="point.pt"
      ></div>
      <matting v-show="matting.current.show" :loading="matting.current.loading" @finish="finishMatting('current')" @cancel="cancelMatting('current')"></matting>
    </div>
    <!-- 路径动画后的位置和帮助部分 -->
    <div v-if="hasFuture" class="future" :style="futureStyle">
      <div class="content" v-html="contentHTMLF" ref="futureContent"></div>
    </div>
    <div
      v-if="hasFuture || matting.isMatting"
      :class="{'future-help': true, active: selectWhich === 'future' || matting.isMatting}"
      data-action="future-move"
      :style="futureHandStyle"
      ref="futureMoveRef"
    >
      <div
        :class="'op-handle-point op-handle-' + point.action"
        v-for="point in futurePoint"
        :data-id="sprite ? sprite.id : ''"
        :data-action="point.action"
        :style="point.pt"
      ></div>
      <matting v-show="matting.future.show" :loading="matting.future.loading" @finish="finishMatting('future')" @cancel="cancelMatting('future')"></matting>
    </div>
    <!-- 路径动画的路径和帮助部分 -->
    <div class="direction" :style="directionStyle">
      <div id="directionSVG"></div>
      <div class="begin-circle" :style="beginCircleStyle"></div>
      <div class="end-triangle" :style="endTriangleStyle"></div>
    </div>
    <div
      :class="{'direction-help': true, active: selectWhich === 'direction'}"
      data-action="direction-move"
      :style="directionStyle"
      @dblclick="editFreePath"
    >
      <div
        :class="'op-handle-point op-handle-' + point.action"
        v-for="point in directionPoint"
        :data-id="sprite ? sprite.id : ''"
        :data-action="point.action"
        :style="point.pt"
      ></div>
    </div>
    <div v-show="pathType==='Bessel'" class="bessel-box">
      <div class="begin-box" :style="beginBoxStyle">
        <div class="bessel-one" data-action="bpfo"></div>
        <div class="bessel-two" data-action="bpft"></div>
      </div>
      <div class="end-box" :style="endBoxStyle">
        <div class="bessel-three" data-action="bpfth"></div>
        <div class="bessel-four" data-action="bpff"></div>
      </div>
    </div>
    <!-- 元素的按钮部分 -->
    <div
      v-show="!matting.isMatting && sprite && !dataAction || dataAction  === 'button'"
      class="handle-button"
      :style="handleStyle"
    >
      <!-- <div class="op-handle-button op-handle-setting" data-action="button" @click="actionHandle($event, 'setting')"></div>
      <div class="op-handle-button op-handle-delete" data-action="button"  @click="actionHandle($event, 'delete')"></div>
      <div v-show="selectWhich === 'direction' && pathType === 'Ellipse'" class="op-handle-button op-handle-ccw" data-action="button"  @click="actionHandle($event, 'ccw')"></div>
      <div v-show="selectWhich === 'direction'" class="op-handle-button op-handle-play" data-action="button"  @click="actionHandle($event, 'play')"></div>-->
      <el-tooltip
        effect="dark"
        placement="top"
        :open-delay="500"
        :value="info.active"
        v-for="info,k in button[selectWhich]"
        :key="info.action"
        v-if="!info.hide"
      >
        <div slot="content" v-html="info.active ? info.helpText1 : info.helpText"></div>
        <div
          :class="'op-handle-button op-handle-' + info.action"
          data-action="button"
          @click="actionHandle($event, info.action)"
          @mouseenter="button[selectWhich][k].active=false"
        ></div>
      </el-tooltip>
    </div>
    <div id="handle_auxiliary_path_line_box"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import getNavType from "@/components/mixins/getNavType";
import dragFn from "@/components/mixins/forDragFn";
import handleCrop from "@/components/mixins/handleCrop";
import matting from './setPathAnim/matting';
import judgeMatting from '../mixins/judgeMatting';

export default {
  mixins: [getNavType, dragFn, handleCrop, judgeMatting],
  components: {
    matting
  },
  data() {
    return {
      ANALYSIS: {
        cw: {
          category: "route_animation_setting",
          action: "click_clockwise_direction",
          label: "路径动画_顺时针运动"
        },
        ccw: {
          category: "route_animation_setting",
          action: "click_anticlockwise_direction",
          label: "路径动画_逆时针运动"
        },
        delete: {
          category: "route_animation_setting",
          action: "click_delete_route",
          label: "路径动画_删除路径"
        },
        preview: {
          category: "route_animation_setting",
          action: "click_route_animation_preview",
          label: "路径动画_预览路径"
        },
        currentSetPath: {
          category: "route_animation_setting",
          action: "click_start_setting_route",
          label: "路径动画_A点_设置路径"
        },
        futureSetPath: {
          category: "route_animation_setting",
          action: "click_end_setting_route",
          label: "路径动画_B点_设置路径"
        },
        swap: {
          category: "route_animation",
          action: "click_swap",
          label: "路径动画_替换"
        },
        addPic: {
          category: "route_animation",
          action: "click_add_picture",
          label: "路径动画_添加图片"
        },
        editPic: {
          category: "route_animation",
          action: "click_edit_picture",
          label: "路径动画_编辑图片"
        },
        bpf: {
          category: "route_animation",
          action: "drag_curve_path_besselpoi",
          label: "路径动画_拖拽_曲线路径_贝塞尔辅助点"
        }
      },
      matting: {
        url: '',
        isMatting: false,
        future: {
          show: false,
          loading: false,
        },
        current: {
          show: false,
          loading: false,
        },
      },
      isShow: false, // 控制路径动画设置是否显示
      sprite: null, // 当前路径动画的元素
      pathType: "Path", // 路径动画类型
      hasFuture: true, // 是否存在终点
      setFreePath: false, // 是否正在进行路径设置
      selectWhich: "direction", // 当前选中的
      dataAction: "", // 用于鼠标点击动作的字符串
      contentHTML: "", // 元素的dom结构的html
      contentHTMLF: "", // 元素的dom结构的html
      currentPoint: [], // 八个小点的信息
      futurePoint: [],
      directionPoint: [],
      current: {
        // 当前位置的样式信息
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        rotate: 0,
        flip: false,
        opacity: 1,
        fillColor: undefined
      },
      future: {
        // 路径动画结束后的样式
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        rotate: 0,
        flip: false,
        opacity: 1,
        fillColor: undefined
      },
      pitchOn: {}, // 用于鼠标移动事件，保存数据的对象
      direction: {
        // 箭头和虚线的样式信息
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        rotate: 0
      },
      rotateInfo: {
        // 旋转角度的样式信息
        top: 0,
        left: 0,
        deg: 0
      },
      handleInfo: {
        // 帮助按钮的定位
        top: 0,
        left: 0
      },
      cancelPathInfo: {
        top: 0,
        left: 0
      },
      mpos: {}, // mousedown 事件的初始化数据对象
      isMousemove: false, // 是否有触发mousemove事件
      textOffset: {
        // 文字的缩放产生的位移
        x: 0,
        y: 0
      },
      cursorArr: [
        "s-resize",
        "sw-resize",
        "w-resize",
        "nw-resize",
        "n-resize",
        "ne-resize",
        "e-resize",
        "se-resize"
      ],
      svgDom: null,
      directionInfo: {
        // 存放路径和象限
        path: [],
        quadrant: 0
      },
      pathAnim: {},
      spriteBox: null, // 同时也是判断是否清空撤销栈
      button: {
        current: [
          { action: "setting", helpText: "设置" },
          { action: "setPath", helpText: "设置路径" },
          { action: "addPic", helpText: "添加图片", hide: true },
          { action: "editPic", helpText: "编辑图片", hide: true },
          { action: "delete", helpText: "删除" },
          { action: "lock", helpText: "锁定", hide: false },
          { action: "matting", helpText: "抠图", hide: true},
          { action: "swap", helpText: "替换", hide: false },
          { action: "favorite", helpText: "收藏", hide: true }
        ],
        direction: [],
        future: [
          { action: "settingT", helpText: "设置" },
          { action: "cancelPath", helpText: "删除路径" },
          { action: "setPath", helpText: "设置路径" },
          { action: "addPic", helpText: "添加图片", hide: true },
          { action: "editPic", helpText: "编辑图片", hide: true },
          { action: "lock", helpText: "锁定", hide: false },
          { action: "matting", helpText: "抠图", hide: true},
          { action: "swap", helpText: "替换", hide: false },
          { action: "favorite", helpText: "收藏", hide: true }
        ]
      },
      firstIn: 0,
      adsorbArr: [],
      adsorbData: [],
      auxiliary: null,
      spinLine: null,
      netLine: null,
      spinLineData: {
        width: 500,
        height: 500,
        top: 500,
        left: 500
      },
      favoriteStatus: 0, // 收藏状态 0 未收藏 1 在收藏 2 已收藏
      favoriteId: '' // 收藏的ID
    };
  },
  computed: {
    ...mapGetters([
      "SelectSprites_Msg",
      "TOOL",
      "Tool_Size",
      "MaterialPane_Size",
      "TopNav_Size",
      "SelectScenes_Msg",
      "MaterialNavReady"
    ]),
    // 以下为对应的样式变量
    setPathAnimStyle() {
      const style = {};
      style.width = this.TOOL.clientWidth + "px";
      style.height = this.TOOL.clientHeight + "px";
      style.top = this.TOOL.fixTop + "px";
      style.left = this.TOOL.fixLeft + "px";
      return style;
    },
    currentStyle() {
      const style = {};
      style.width = this.current.width + "px";
      style.height = this.current.height + "px";
      style.top = this.current.top + "px";
      style.left = this.current.left + "px";
      style.opacity = this.current.opacity;
      style.transform =
        "rotate(" +
        this.current.rotate +
        "deg)" +
        (this.current.flip ? " scaleX(-1)" : "");
      return style;
    },
    currentHandStyle() {
      const style = {};
      style.width = this.current.width + "px";
      style.height = this.current.height + "px";
      style.top = this.current.top + "px";
      style.left = this.current.left + "px";
      style.transform = "rotate(" + this.current.rotate + "deg)";
      return style;
    },
    futureStyle() {
      const style = {};
      style.width = this.future.width + "px";
      style.height = this.future.height + "px";
      style.top = this.future.top + "px";
      style.left = this.future.left + "px";
      style.opacity = this.future.opacity;
      style.transform =
        "rotate(" +
        this.future.rotate +
        "deg)" +
        (this.current.flip ? " scaleX(-1)" : "");
      return style;
    },
    futureHandStyle() {
      const style = {};
      style.width = this.future.width + "px";
      style.height = this.future.height + "px";
      style.top = this.future.top + "px";
      style.left = this.future.left + "px";
      style.transform = "rotate(" + this.future.rotate + "deg)";
      return style;
    },
    directionStyle() {
      const style = {};
      style.opacity = 1;
      style.width = this.direction.width + "px";
      style.height = this.direction.height + "px";
      style.top = this.direction.top + "px";
      style.left = this.direction.left + "px";
      style.transform = "rotate(" + this.direction.rotate + "deg)";
      this.setFreePath && (style.display = 0);
      return style;
    },
    rotateStyle() {
      const style = {};
      style.top = this.rotateInfo.top + "px";
      style.left = this.rotateInfo.left + "px";
      return style;
    },
    handleStyle() {
      const style = {};
      style.top = this.handleInfo.top + "px";
      style.left = this.handleInfo.left + "px";
      return style;
    },
    cancelPathStyle() {
      const style = {};
      style.top = this.cancelPathInfo.top + "px";
      style.left = this.cancelPathInfo.left + "px";
      return style;
    },
    beginCircleStyle() {
      // 圆圈的样式，定位
      const style = {};
      style.top = this.direction.top;
      switch (this.directionInfo.quadrant) {
        case 1:
          style.top = "-8px";
          style.left = "-8px";
          break;
        case 2:
          style.top = "calc(100% - 8px)";
          style.left = "-8px";
          break;
        case 3:
          style.top = "calc(100% - 8px)";
          style.left = "calc(100% - 8px)";
          break;
        case 4:
          style.top = "-8px";
          style.left = "calc(100% - 8px)";
          break;
        case 5:
          style.display = "none";
          break;
        case 6:
          style.top = this.directionInfo.points[0][3] - 8 + "px";
          style.left = this.directionInfo.points[0][2] - 8 + "px";
          break;
        case 7:
          style.top = this.directionInfo.path[1] - 8 + "px";
          style.left = this.directionInfo.path[0] - 8 + "px";
          break;
      }
      return style;
    },
    endTriangleStyle() {
      // 箭头的样式，定位
      const style = {};
      let arr = this.directionInfo.path && this.directionInfo.path.slice(-4);
      style.top = this.direction.top;
      switch (this.directionInfo.quadrant) {
        case 1:
          style.top = "calc(100% - 13px)";
          style.left = "calc(100% - 9px)";
          style.transform =
            "rotate(" +
            (180 +
              this._angle(arr[0], arr[1], arr[2], arr[1], arr[2], arr[3])) +
            "deg)";
          break;
        case 2:
          style.top = "-13px";
          style.left = "calc(100% - 9px)";
          style.transform =
            "rotate(" +
            this._angle(arr[0], arr[1], arr[2], arr[1], arr[2], arr[3]) +
            "deg)";
          break;
        case 3:
          style.top = "-13px";
          style.left = "-9px";
          style.transform =
            "rotate(" +
            this._angle(arr[0], arr[1], arr[2], arr[1], arr[2], arr[3]) +
            "deg)";
          break;
        case 4:
          style.top = "calc(100% - 13px)";
          style.left = "-9px";
          style.transform =
            "rotate(" +
            (180 +
              this._angle(arr[0], arr[1], arr[2], arr[1], arr[2], arr[3])) +
            "deg)";
          break;
        case 5:
          style.top = undefined;
          this.button.direction[2].action === "ccw" &&
            (style.transform = "rotate(180deg)");
          break;
        case 6:
          arr = this.directionInfo.points[this.directionInfo.points.length - 1];
          arr = [].concat(arr);
          if (this.directionInfo.freePathType === "line") {
            arr[0] = this.directionInfo.points[
              this.directionInfo.points.length - 2
            ][2];
            arr[1] = this.directionInfo.points[
              this.directionInfo.points.length - 2
            ][3];
          }
          if (this.directionInfo.close) {
            arr = this.directionInfo.points[0];
            arr = [].concat(arr);
            if (this.directionInfo.freePathType === "line") {
              arr[0] = this.directionInfo.points[
                this.directionInfo.points.length - 1
              ][2];
              arr[1] = this.directionInfo.points[
                this.directionInfo.points.length - 1
              ][3];
            }
          }
        case 7:
          style.top = arr[3] - 11 + "px";
          style.left = arr[2] - 9 + "px";
          style.transform =
            "rotate(" +
            (-90 + this._angelT(arr[2], arr[3], arr[0], arr[1])) +
            "deg)";
          break;
      }
      return style;
    },
    beginBoxStyle() {
      const style = {};
      let arr = this.directionInfo.path;
      let len = this._len(arr[0], arr[1], arr[2], arr[3]);
      style.width = len * 2 + "px";
      style.top = this.direction.top + arr[1] + "px";
      style.left = this.direction.left + arr[0] - len + "px";
      style.transform =
        "rotate(" + this._angelT(arr[2], arr[3], arr[0], arr[1]) + "deg)";
      return style;
    },
    endBoxStyle() {
      const style = {};
      let arr = this.directionInfo.path.slice(-4);
      let len = this._len(arr[0], arr[1], arr[2], arr[3]);
      style.width = len * 2 + "px";
      style.top = this.direction.top + arr[3] + "px";
      style.left = this.direction.left + arr[2] - len + "px";
      style.transform =
        "rotate(" + this._angelT(arr[2], arr[3], arr[0], arr[1]) + "deg)";
      return style;
    }
  },
  watch: {
    SelectSprites_Msg(val, oldVal) {
      this.sprite && this.sprite.showHideSpriteDom(true);
      this.initData();
    },
    "sprite.font"(val) {
      this.isShow && this.caclData();
    },
    "sprite.opacity"(val) {
      if (this.isShow) {
        this.caclData();
        this.sprite.effect.init();
      }
    },
    "sprite.flip"(val) {
      this.isShow && this.caclData();
    },
    "sprite.border": {
      handler() {
        if (this.isShow) {
          this.caclData();
          this.$nextTick(() => {
            this.handleCrop("currentContent");
            this.handleCrop("futureContent");
          });
        }
      },
      deep: true
    },
    "sprite.boxShadow": {
      handler() {
        if (this.isShow) {
          this.caclData();
        }
      },
      deep: true
    },
    "sprite.dropShadow": {
      handler() {
        if (this.isShow) {
          this.caclData();
          this.$nextTick(() => {
            this.handleCrop("currentContent");
            this.handleCrop("futureContent");
          });
        }
      },
      deep: true
    },
    "sprite.bgColor"(val) {
      this.isShow && this.caclData();
    },
    "TOOL.clientWidth"(val, oldVal) {
      this.caclData();
    },
    "TOOL.clientHeight"(val, oldVal) {
      this.caclData();
    },
    isShow(val) {
      if (val) {
        this.$nextTick(() => {
          this.handleCrop("currentContent");
          this.handleCrop("futureContent");
        });
      }
    }
  },
  mounted() {
    this.$bus.on('set-pathAnim-matting', () => {
      if (this.selectWhich === 'direction') {
        return;
      }
      this.doMatting();
    });
    this.$bus.on("updateEffect_vue", data => {
      if (data.type === "path") {
        // 更新路径动画后
        this.initData();
        this.$nextTick(() => {
          this.handleCrop("currentContent");
          this.handleCrop("futureContent");
        });
      } else if (data.type === "svgCroping") {
        this.isShow = false;
      } else if (data.type === "svgCropSet") {
        setTimeout(() => {
          this.initData();
        }, 100);
      }
    });
    this.$bus.on("undoRedoHandle", data => {
      // 撤销和恢复的事件
      (data.type === "updateSpriteEffect" ||
        data.type === "updateHandle" ||
        data.type === "path_dragPathUp") &&
        this.caclData();
      // 快进到设置自由路径动画防止执行initData，否则绘画路径时，setPathAnim会显示出来
      data.type === "path_pathType" && data.mod !== "_redo" && this.initData();
    });
    this.$bus.on("set_path_anim", data => {
      if (data.action === "init") {
        if (data.pathAnim) {
          this.initData(data.pathAnim);
          // 防止设置好后，路径并没有正在设置
          this.updateEffect();
          this.$nextTick(() => {
            this.handleCrop("currentContent");
            this.handleCrop("futureContent");
          });
        } else {
          this.initData();
        }
      } else if (
        data.action === "paint" ||
        data.action === "undo" ||
        data.action === "edit"
      ) {
        // 让本弹窗隐藏，显示画布元素
        this.setFreePath = true;
      } else if (data.action === "close") {
        this.setFreePath = false;
      }
    });
    this.$bus.on("timeline_play_scenes", data => {
      // 停止播放的化清空spriteBox
      !data.isPlay && (this.spriteBox = null);
    });
    this.$bus.on("colorPickerInput.setting_Svg", (obj, opt) => {
      if (!this.isShow) return;
      if (opt.type === "fill") {
        this.changeSvgStyle(this.$refs["currentContent"], { fill: obj.hex });
      } else if (opt.type === "stroke") {
        this.changeSvgStyle(this.$refs["currentContent"], { stroke: obj.hex });
        this.changeSvgStyle(this.$refs["futureContent"], { stroke: obj.hex });
      }
    });
    this.$bus.on("colorPickerInput.pathTargetSetting", obj => {
      if (!this.isShow) return;
      // this.sprite.updateSprite({
      //   fill: obj.hex
      // })
      // this.initStyleInfo('Svg')
      if (this.future.fillColor) {
        this.changeSvgStyle(this.$refs["futureContent"], { fill: obj.hex });
        this.future.fillColor = obj.hex;
      } else {
        this.$refs["futureContent"].children[0].style.color = obj.hex;
        this.future.textColor = obj.hex;
      }
      this.updateEffect();
    });
    this.$bus.on("targetSetting_opacity", data => {
      this.future.opacity = (100 - data.val) / 100;
      if (data.undo) {
        this.updateEffect();
      }
    });
    this.$bus.on("strokeWidthUpdated_vue", data => {
      if (this.isShow && data) {
        this.changeSvgStyle(this.$refs["futureContent"], { strokeWidth: data });
        this.changeSvgStyle(this.$refs["currentContent"], {
          strokeWidth: data
        });
      }
    });
    this.$bus.on("format-brush-status", data => {
      // 格式刷事件
      if (data.status === "push" && this.isShow) {
        this.isShow = false;
        if (this.firstIn === 1) {
          this.button.direction[0].active = false;
          this.button.direction[
            this.button.direction.length - 1
          ].active = false;
        }
        if (this.sprite) {
          this.sprite.showHideSpriteDom(true);
          this.sprite = null;
        }
      }
    });
    this.$nextTick(() => {
      // 路径svg元素
      this.svgDom = SVG("directionSVG").size(100, 100);
      this.createDomBox();
    });
  },
  methods: {
    cancelMatting (type) {
      let url = this.$handleAssetsUrl(this.sprite.option.url);
      $(`.future .content img`).attr('src', url);
      $(`.current .content img`).attr('src', url);
      this.matting[type].show = false;
      this.matting[type].loading = false;
      this.matting.isMatting = false;
    },
    finishMatting () {
      let id = this.sprite.id;
      let url = this.matting.url;
      let oldUrl = this.sprite.option.url;
      let img = $(`#sprite-${id} img`);
      let playImg = $(`#player-sprite-${id} img`);
      this.matting.isMatting = false;
      this.matting.current.show = false;
      this.matting.future.show = false;
      this.sprite.option.url = url;
      playImg.attr('src', this.$handleAssetsUrl(url));
      img.attr('src', this.$handleAssetsUrl(url));
      this.matting.url = '';
      eve("undo_redo", null, {
        type: "animMatting",
        data: {
          animSprite: Object.assign({},this.sprite),
          animUrl: url,
          animOldUrl: oldUrl,
          future: $(`.future .content img`),
          current: $(`.current .content img`),
          spriteImg: img,
          playImg
        }
      });
    },
    initData(data) {
      // 初始化数据(与calcData相比会重置某些属性)
      if (
        this.SelectSprites_Msg &&
        this.SelectSprites_Msg.length === 1 &&
        (data || this.SelectSprites_Msg[0].effect.pathAnim.end) &&
        !this.SelectSprites_Msg[0].locked
      ) {
        // 传入的data为pathAnim对象
        this.sprite = this.SelectSprites_Msg[0];
        if (this.sprite.action === "editFrame") {
          this.sprite.action = null;
          this.sprite = null;
          return;
        }
        this.isShow = true;
        this.firstIn++;
        // 切换栈
        // this.$bus.emit('change_undo_type', {
        //   type: 'Path',
        // });

        if (!data) {
          this.pathAnim = this.sprite.effect.pathAnim;
        } else {
          this.pathAnim = data;
        }
        this.pathType = this.pathAnim.type || "Path";

        this.hasFuture = true;
        if (this.pathType === "Ellipse") this.hasFuture = false;
        // 隐藏元素
        // this.sprite && this.sprite.showHideSpriteDom(false);

        this.currentPoint = [
          { pt: { left: "calc(50% - 4px)", bottom: "-4px" }, action: "s" },
          { pt: { left: "-6px", bottom: "-6px" }, action: "sw" },
          { pt: { left: "-3.5px", top: "calc(50% - 4px)" }, action: "w" },
          { pt: { left: "-6px", top: "-6px" }, action: "nw" },
          { pt: { left: "calc(50% - 4px)", top: "-4px" }, action: "n" },
          { pt: { right: "-6px", top: "-6px" }, action: "ne" },
          { pt: { right: "-3.5px", top: "calc(50% - 4px)" }, action: "e" },
          {
            pt: { right: "-6px", bottom: "-6px", left: "auto", top: "auto" },
            action: "se"
          },
          { pt: { right: "-20px", bottom: "-20px" }, action: "spin" }
        ];
        this.futurePoint = JSON.parse(JSON.stringify(this.currentPoint));
        if (this.pathType === "Ellipse") {
          this.directionPoint = this.futurePoint;
          this.button.direction = [
            {
              action: "setPath",
              helpText: "设置路径",
              active: false,
              helpText1: "点击设置路径<br>动画，让素材<br>的运动更丰富"
            },
            { action: "cancelPath", helpText: "删除路径", active: false },
            { action: "cw", helpText: "设置方向", active: false },
            {
              action: "play",
              helpText: "预览",
              active: false,
              helpText1:
                "素材会随着线<br>框中的路径运<br>动，点击预览<br>查看动画效果"
            }
          ];
          if (this.pathAnim.info && this.pathAnim.info.ccw) {
            this.button.direction[2].action = "ccw";
          }
        } else if (this.pathType === "FreePath") {
          this.directionPoint = [];
          this.button.direction = [
            {
              action: "setPath",
              helpText: "设置路径",
              active: false,
              helpText1: "点击设置路径<br>动画，让素材<br>的运动更丰富"
            },
            { action: "cancelPath", helpText: "删除路径", active: false },
            { action: "editPath", helpText: "编辑路径", active: false },
            {
              action: "play",
              helpText: "预览",
              active: false,
              helpText1:
                "素材会随着线<br>框中的路径运<br>动，点击预览<br>查看动画效果"
            }
          ];
        } else {
          this.directionPoint = [];
          this.button.direction = [
            {
              action: "setPath",
              helpText: "设置路径",
              active: false,
              helpText1: "点击设置路径<br>动画，让素材<br>的运动更丰富"
            },
            { action: "cancelPath", helpText: "删除路径", active: false },
            {
              action: "play",
              helpText: "预览",
              active: false,
              helpText1:
                "素材会随着线<br>框中的路径运<br>动，点击预览<br>查看动画效果"
            }
          ];
        }
        this.button.current[2].hide = true;
        this.button.current[3].hide = true;
        this.button.future[3].hide = true;
        this.button.future[4].hide = true;
        if (this.sprite.type === "Frame") {
          if (this.sprite.picData.picSize) {
            this.button.current[3].hide = false;
            this.button.future[4].hide = false;
          } else {
            this.button.current[2].hide = false;
            this.button.future[3].hide = false;
          }
        }
        this.button.current[6].hide = true;
        this.button.future[6].hide = true;
        switch(this.sprite.type) {
          case 'Image':
            this.button.current[6].hide = false;
            this.button.future[6].hide = false;
          case 'Lottie':
          case 'Svg':
          case 'Frame':
          case 'Gif':
          this.button.current[8].hide = false;
          this.button.future[8].hide = false;
          break;
        }

        // 打开后默认选中路径选框
        this.selectWhich = "direction";
        // 不然不会有用
        this.$nextTick(() => {
          // this.button.direction[0].active = this.firstIn === 1 ? true: false;
          this.button.direction[this.button.direction.length - 1].active =
            this.firstIn === 1 ? true : false;
        });
        this.caclData(data);

        // 选中后默认弹开路径动画设置弹窗（没有setTimeout弹窗不会弹出）
        setTimeout(() => {
          let popD = {};
          popD.type = 1;
          popD.sprite = this.sprite;
          popD.initialX =
            this.direction.left +
            this.MaterialPane_Size.width +
            this.TOOL.fixLeft -
            270;
          popD.initialY =
            this.direction.top +
            this.TopNav_Size.height +
            this.TOOL.fixTop +
            40;
          popD.name = "effectSetting";
          popD.contentType = "pathAnim";
          this.$bus.emit("FeaturesPop_vue", popD);
        });
      } else {
        this.isShow = false;
        this.setFreePath = false;
        if (this.firstIn === 1) {
          this.button.direction[0].active = false;
          this.button.direction[
            this.button.direction.length - 1
          ].active = false;
        }
        // 切换栈，并清空栈
        // this.$bus.emit('change_undo_type', {
        //   type: '',
        //   clearStack: this.spriteBox ? false : true
        // })
        if (this.sprite) {
          this.sprite.showHideSpriteDom(true);
          this.sprite = null;
        }
      }
    },
    caclData(data) {
      if (!this.isShow) return;
      !data && (this.pathAnim = this.sprite.effect.pathAnim);
      if (!this.pathAnim.target) {
        this.dataAction = null;
        this.mpos = null;
        this.isShow = false;
        this.setFreePath = false;
        this.sprite.showHideSpriteDom(true);
        this.sprite = null;
        return;
      }
      // 初始化各种样式的数据（包括文字的样式）
      this.initStyleInfo(this.sprite.type);
      // 帮助按钮的位置计算
      this.calcPosition();
      // 显示旋转角度的样式
      this.getRotateInfo();
    },
    initStyleInfo(type) {
      // 初始化各种样式的数据（包括文字的样式）
      let dom = this.sprite
          .getThumbnail("setPath")
          .css({ width: "100%", height: "100%" }),
        domF = null;
      let fuInfo = null;

      this.current = {
        width: this.sprite.width,
        height: this.sprite.height,
        top: this.sprite.positionTop,
        left: this.sprite.positionLeft,
        rotate: this.sprite.rotate,
        flip: this.sprite.flip,
        opacity: this.sprite.opacity
      };
      // 获取路径动画的终点位置，没有就不给
      fuInfo = this.getFutureInfo();
      if (fuInfo) {
        this.future = {
          top: fuInfo.top,
          left: fuInfo.left,
          rotate: fuInfo.rotate,
          width: fuInfo.width,
          height: fuInfo.height,
          opacity: fuInfo.opacity
        };
      }

      if (type === "Text") {
        this.button.current[1].hide = true;
        this.button.future[3].hide = true;
        // 文字dom的创建
        dom.css({
          fontSize: this.sprite.font.fontSize + "px",
          fontFamily: `"${this.sprite.font.fontFamilyUrl.split("/").pop()}"`,
          fontWeight: this.sprite.font.fontWeight,
          fontStyle: this.sprite.font.fontStyle,
          textDecoration: this.sprite.font.textDecoration,
          textAlign: this.sprite.font.textAlign,
          color: this.sprite.font.color,
          opacity: this.sprite.font.opacity,
          overflow: "visible"
        });
        dom
          .children("div")
          .attr({ class: "text-clip" })
          .css({
            transform: "scale(" + 1 / this.TOOL.scale + ")",
            transformOrigin: "0px 0px 0px",
            wordBreak: "break-word",
            wordWrap: "break-word",
            whiteSpace: "pre-wrap",
            lineHeight: this.sprite.lineHeight,
            letterSpacing:
              parseFloat(
                this.sprite.letterSpacing *
                  ~~(parseInt(this.sprite.font.fontSize) / 10) || 0
              ) + "px",
            writingMode: this.sprite.font.writingMode,
            filter: this.sprite.dropShadow
              ? `drop-shadow(${this.sprite.getShadowCss("dropShadow")})`
              : ""
          })
          .css(this.sprite.artStyle || {});

        this.future.width = this.sprite.width;
        this.future.height = this.sprite.height;

        if (this.sprite.versionAnyway !== "Vertical") {
          this.currentPoint = [].concat([
            {
              pt: {
                left: "-6px",
                top: "calc(50% - 6px)",
                width: "12px",
                height: "12px"
              },
              action: "w"
            },
            {
              pt: {
                right: "-6px",
                top: "calc(50% - 6px)",
                width: "12px",
                height: "12px"
              },
              action: "e"
            },
            { pt: { right: "-20px", bottom: "-20px" }, action: "spin" }
          ]);
          dom.children("div").css({
            width: this.sprite.width * this.TOOL.scale,
            height: "auto"
          });
        } else {
          this.currentPoint = [].concat([
            {
              pt: {
                left: "calc(50% - 4px)",
                bottom: "-6px",
                width: "12px",
                height: "12px"
              },
              action: "s"
            },
            {
              pt: {
                left: "calc(50% - 4px)",
                top: "-6px",
                width: "12px",
                height: "12px"
              },
              action: "n"
            },
            { pt: { right: "-20px", bottom: "-20px" }, action: "spin" }
          ]);
          dom.children("div").css({
            width: "auto",
            height: this.sprite.height * this.TOOL.scale
          });
        }
        domF = dom.clone();
        if (!this.sprite.artType) {
          this.future.textColor =
            this.pathAnim.target.textColor || this.sprite.font.color;
          domF.css({
            color: this.future.textColor
          });
        }
        this.futurePoint = $.extend(true, [], this.currentPoint);
      } else if (type === "Lottie" || type === "Frame" || type === "Video") {
        this.currentPoint = [
          { pt: { left: "-6px", bottom: "-6px" }, action: "sw" },
          { pt: { left: "-6px", top: "-6px" }, action: "nw" },
          { pt: { right: "-6px", top: "-6px" }, action: "ne" },
          {
            pt: { right: "-6px", bottom: "-6px", left: "auto", top: "auto" },
            action: "se"
          },
          { pt: { right: "-20px", bottom: "-20px" }, action: "spin" }
        ];
        this.futurePoint = [
          { pt: { left: "-6px", bottom: "-6px" }, action: "sw" },
          { pt: { left: "-6px", top: "-6px" }, action: "nw" },
          { pt: { right: "-6px", top: "-6px" }, action: "ne" },
          {
            pt: { right: "-6px", bottom: "-6px", left: "auto", top: "auto" },
            action: "se"
          },
          { pt: { right: "-20px", bottom: "-20px" }, action: "spin" }
        ];
      } else if (
        type === "Svg" &&
        this.$isEditableShape(this.sprite.option.fileType)
      ) {
        this.current.fillColor = this.sprite.fill;
        this.future.fillColor =
          this.pathAnim.target.fillColor || this.sprite.fill;
        domF = this.sprite
          .getThumbnail()
          .css({ width: "100%", height: "100%" });
        this.changeSvgStyle(
          domF[0],
          { fill: this.future.fillColor },
          this.sprite
        );
        this.changeSvgStyle(
          dom[0],
          { fill: this.current.fillColor },
          this.sprite
        );
      } else if (type === "Chart") {
        this.button.current[1].hide = true;
        this.button.future[3].hide = true;
      } else if (type === "RichText") {
        if (this.sprite.versionAnyway !== "Vertical") {
          this.currentPoint = [].concat([
            {
              pt: {
                left: "-6px",
                top: "calc(50% - 6px)",
                width: "12px",
                height: "12px"
              },
              action: "w"
            },
            {
              pt: {
                right: "-6px",
                top: "calc(50% - 6px)",
                width: "12px",
                height: "12px"
              },
              action: "e"
            },
            { pt: { right: "-20px", bottom: "-20px" }, action: "spin" }
          ]);
          dom.children("div").css({
            width: this.sprite.width * this.TOOL.scale,
            height: "auto"
          });
        } else {
          this.currentPoint = [].concat([
            {
              pt: {
                left: "calc(50% - 4px)",
                bottom: "-6px",
                width: "12px",
                height: "12px"
              },
              action: "s"
            },
            {
              pt: {
                left: "calc(50% - 4px)",
                top: "-6px",
                width: "12px",
                height: "12px"
              },
              action: "n"
            },
            { pt: { right: "-20px", bottom: "-20px" }, action: "spin" }
          ]);
          dom.children("div").css({
            width: "auto",
            height: this.sprite.height * this.TOOL.scale
          });
        }
        this.futurePoint = $.extend(true, [], this.currentPoint);
      }

      this.contentHTML = dom.prop("outerHTML");
      this.contentHTMLF = this.contentHTML;
      domF && (this.contentHTMLF = domF.prop("outerHTML"));
      this.getDirectionInfo();
      this.setCursor(this.current.rotate, type, "current");
      this.setCursor(this.future.rotate, type, "future");
      // this.setCursor(this.direction.rotate, 'direction', 'direction');
      this.setBorderRadius();
    },
    setBorderRadius() {
      this.$nextTick(() => {
        if (this.sprite.border) {
          let ratio =
              this.sprite.width > this.sprite.height
                ? this.sprite.width
                : this.sprite.height,
            radius = [],
            str = "";
          for (i in this.sprite.border.radius) {
            radius.push((this.sprite.border.radius[i] * ratio) / 100);
          }
          str = radius.join("px ") + "px";
          this.$refs["currentContent"].style.overflow = "hidden";
          this.$refs["currentContent"].style.borderRadius = str;
          if (this.$refs["futureContent"]) {
            this.$refs["futureContent"].style.overflow = "hidden";
            this.$refs["futureContent"].style.borderRadius = str;
          }
        } else {
          this.$refs["currentContent"].style.overflow = "";
          this.$refs["currentContent"].style.borderRadius = "";
          if (this.$refs["futureContent"]) {
            this.$refs["futureContent"].style.overflow = "";
            this.$refs["futureContent"].style.borderRadius = "";
          }
        }
        if (this.sprite.boxShadow) {
          let str1 = this.sprite.getShadowCss("boxShadow");
          this.$refs["currentContent"].style.boxShadow = str1;
          this.$refs["futureContent"] &&
            (this.$refs["futureContent"].style.boxShadow = str1);
        } else {
          this.$refs["currentContent"].style.boxShadow = "";
          this.$refs["futureContent"] &&
            (this.$refs["futureContent"].style.boxShadow = "");
        }
        this.$refs[
          "currentContent"
        ].style.backgroundColor = this.sprite.bgColor;
        this.$refs["futureContent"] &&
          (this.$refs[
            "futureContent"
          ].style.backgroundColor = this.sprite.bgColor);
      });
    },
    getFutureInfo() {
      // 获取路径动画终点位置信息
      let option = null,
        target = this.pathAnim.target;

      option = {
        rotate:
          typeof target.rotate === "number"
            ? target.rotate
            : this.current.rotate,
        width: target.w || this.current.width,
        height: target.h || this.current.height,
        top: target.y || this.current.top,
        left: target.x || this.current.left,
        opacity:
          typeof target.opacity === "number"
            ? target.opacity
            : this.sprite.opacity
      };

      return option;
    },
    getRotateInfo() {
      // 显示旋转角度的样式
      if (!this.sprite || this.dataAction !== "spin") return;
      this.rotateInfo.top =
        this[this.selectWhich].top + this[this.selectWhich].height / 2 - 15;
      this.rotateInfo.left =
        this[this.selectWhich].left + this[this.selectWhich].width / 2 - 15;
      this.rotateInfo.deg = Math.round(this[this.selectWhich].rotate) + "°";
    },
    getDirectionInfo(type) {
      // 从开始位置和路径动画信息确定路径的位置信息
      let data = null;
      let info = null;
      if (type) {
        info = this.getAllInfo(true).info;
      } else {
        info = $.extend(true, {}, this.pathAnim.info);
      }
      let currentCenter = {
          x: this.current.left + this.current.width / 2,
          y: this.current.top + this.current.height / 2
        },
        futureCenter = {
          x: this.future.left + this.future.width / 2,
          y: this.future.top + this.future.height / 2
        };
      if (this.pathType === "Path") {
        this.direction.width = Math.abs(currentCenter.x - futureCenter.x);
        this.direction.height = Math.abs(currentCenter.y - futureCenter.y);

        this.direction.width <= 2 && (this.direction.width = 2);
        this.direction.height <= 2 && (this.direction.height = 2);

        // 判断象限(1象限包含x轴，如此递推)
        //    三 |  二
        // -------------> x
        //    四 |  一
        //       v
        //         y

        switch (true) {
          case currentCenter.x < futureCenter.x &&
            currentCenter.y <= futureCenter.y:
            this.directionInfo.quadrant = 1;
            data = [0, 0, this.direction.width, this.direction.height];
            this.direction.left = currentCenter.x;
            this.direction.top = currentCenter.y;
            break;
          case currentCenter.x <= futureCenter.x &&
            currentCenter.y > futureCenter.y:
            this.directionInfo.quadrant = 2;
            data = [0, this.direction.height, this.direction.width, 0];
            this.direction.left = currentCenter.x;
            this.direction.top = futureCenter.y;
            break;
          case currentCenter.x > futureCenter.x &&
            currentCenter.y >= futureCenter.y:
            this.directionInfo.quadrant = 3;
            data = [this.direction.width, this.direction.height, 0, 0];
            this.direction.left = futureCenter.x;
            this.direction.top = futureCenter.y;
            break;
          case currentCenter.x >= futureCenter.x &&
            currentCenter.y < futureCenter.y:
            this.directionInfo.quadrant = 4;
            data = [this.direction.width, 0, 0, this.direction.height];
            this.direction.left = futureCenter.x;
            this.direction.top = currentCenter.y;
            break;
          default:
            this.directionInfo.quadrant = 1;
            data = [0, 0, 0, 0];
            this.direction.left = currentCenter.x;
            this.direction.top = currentCenter.y;
            break;
        }

        this.direction.rotate = 0;
      } else if (this.pathType === "Ellipse") {
        this.direction.rotate = info.rotate || 0;
        let calcP = this._rotateLinePoint(
          currentCenter,
          info.width / 2,
          this.direction.rotate
        );
        this.direction.width = info.width;
        this.direction.height = info.height;
        this.direction.top = calcP.y - info.height / 2;
        this.direction.left = calcP.x;
        data = [info.width, info.height];
        this.directionInfo.quadrant = 5;
      } else if (this.pathType === "FreePath") {
        this.direction.width = info.width;
        this.direction.height = info.height;
        let fp = info.points[0],
          lp = info.points[info.points.length - 1];

        if (info.close) {
          lp = fp;
        }

        if (type === "current" || !type) {
          this.direction.top = currentCenter.y - fp[3];
          this.direction.left = currentCenter.x - fp[2];
          this.future.left =
            this.direction.left + lp[2] - this.future.width / 2;
          this.future.top = this.direction.top + lp[3] - this.future.height / 2;
        } else if (type === "future") {
          this.direction.top = futureCenter.y - lp[3];
          this.direction.left = futureCenter.x - lp[2];
          this.current.left =
            this.direction.left + fp[2] - this.current.width / 2;
          this.current.top =
            this.direction.top + fp[3] - this.current.height / 2;
        }
        this.direction.rotate = 0;
        data = info;
        this.directionInfo.quadrant = 6;
      } else if (this.pathType === "Bessel") {
        this.direction.width = info.width;
        this.direction.height = info.height;
        if (type === "current" || !type) {
          this.direction.top = currentCenter.y - info.path[1];
          this.direction.left = currentCenter.x - info.path[0];
        } else if (type === "future") {
          this.direction.top = futureCenter.y - info.path[7];
          this.direction.left = futureCenter.x - info.path[6];
        }
        this.directionInfo.quadrant = 7;
        data = info.path;
      }
      this.initDirecionSvg(data);
    },
    initDirecionSvg(data) {
      //生成svg元素
      if (!$("#directionSVG").children().length) {
        this.svgDom = SVG("directionSVG");
      }
      this.svgDom.clear();
      this.svgDom.size(this.direction.width, this.direction.height);

      if (this.pathType === "Path") {
        let pathStr = "M" + data.join(",");
        this.directionInfo.path = data;
        this.svgDom.path(pathStr).attr({
          fill: "none",
          stroke: "#464161",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": 3,
          "stroke-dasharray": "1,7"
        });
      } else if (this.pathType === "Ellipse") {
        this.directionInfo.path.length = 0;
        this.svgDom.ellipse(data[0] - 1, data[1] - 1).attr({
          fill: "none",
          stroke: "#464161",
          "stroke-width": 4,
          "stroke-dasharray": "1,8",
          "stroke-linecap": "round"
        });
      } else if (this.pathType === "Bessel") {
        this.directionInfo.path = data;
        let path = [].concat(data);
        path.splice(2, 0, "C");
        let pathStr = "M" + path.join(" ");
        this.svgDom.path(pathStr).attr({
          fill: "none",
          stroke: "#464161",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": 2,
          "stroke-dasharray": "6,6"
        });
      } else if (this.pathType === "FreePath") {
        this.directionInfo.points = data.points;
        this.directionInfo.close = data.close;
        this.directionInfo.freePathType = data.freePathType;
        let pathStr = this._getPath(data.points, data.freePathType, data.close);
        this.svgDom.path(pathStr).attr({
          fill: "none",
          stroke: "#464161",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": 3,
          "stroke-dasharray": "1,7"
        });
      }
    },
    fromDirection() {
      // 重路径动画的选框推出current和futrue的位置信息
      if (this.pathType === "Path") {
        let caCuLe = this.direction.left - this.current.width / 2 + 1,
          caCuTo = this.direction.top - this.current.height / 2 + 1,
          caFuLe = this.direction.left - this.future.width / 2 + 1,
          caFuTo = this.direction.top - this.future.height / 2 + 1;
        switch (this.directionInfo.quadrant) {
          case 1:
            this.current.left = caCuLe;
            this.current.top = caCuTo;
            this.future.left = caFuLe + this.direction.width;
            this.future.top = caFuTo + this.direction.height;
            break;
          case 2:
            this.current.left = caCuLe;
            this.current.top = caCuTo + this.direction.height;
            this.future.left = caFuLe + this.direction.width;
            this.future.top = caFuTo;
            break;
          case 3:
            this.current.left = caCuLe + this.direction.width;
            this.current.top = caCuTo + this.direction.height;
            this.future.left = caFuLe;
            this.future.top = caFuTo;
            break;
          case 4:
            this.current.left = caCuLe + this.direction.width;
            this.current.top = caCuTo;
            this.future.left = caFuLe;
            this.future.top = caFuTo + this.direction.height;
            break;
        }
      } else if (this.pathType === "Ellipse") {
        // current选框的中心和路径选框的中心
        let centerP1 = {
            x: this.direction.left,
            y: this.direction.top + this.direction.height / 2
          },
          centerP2 = {
            x: this.direction.left + this.direction.width / 2,
            y: this.direction.top + this.direction.height / 2
          };
        let calcP = this._rotateWithPoint(
          centerP1,
          centerP2,
          this.direction.rotate
        );

        this.current.left = calcP.x - this.current.width / 2;
        this.current.top = calcP.y - this.current.height / 2;
        this.initDirecionSvg([this.direction.width, this.direction.height]);
      } else if (this.pathType === "Bessel") {
        this.current.left =
          this.direction.left +
          this.directionInfo.path[0] -
          this.current.width / 2;
        this.current.top =
          this.direction.top +
          this.directionInfo.path[1] -
          this.current.height / 2;
        this.future.left =
          this.direction.left +
          this.directionInfo.path[6] -
          this.future.width / 2;
        this.future.top =
          this.direction.top +
          this.directionInfo.path[7] -
          this.future.height / 2;
      } else if (this.pathType === "FreePath") {
        let fp = this.directionInfo.points[0],
          lp = this.directionInfo.points[this.directionInfo.points.length - 1];

        if (this.directionInfo.close) {
          lp = fp;
        }
        this.current.left =
          this.direction.left + fp[2] - this.current.width / 2;
        this.current.top = this.direction.top + fp[3] - this.current.height / 2;
        this.future.left = this.direction.left + lp[2] - this.future.width / 2;
        this.future.top = this.direction.top + lp[3] - this.future.height / 2;
      }
    },
    dragDown(disx, dataAction) {
      this.isMousemove = false;
      // mousedown事件 初始化一些值
      if (this.firstIn === 1) {
        this.button.direction[0].active = false;
        this.button.direction[this.button.direction.length - 1].active = false;
      }
      if (!dataAction) {
        if (this.matting.isMatting) {
          if (this.matting.url) {
            this.finishMatting();
          }
          return;
        }
        this.isShow = false;
        this.setFreePath = false;
        if (this.sprite) {
          this.sprite.showHideSpriteDom(true);
          this.sprite = null;
        }
        this.TOOL.selectSprite(null);
        return;
      } else {
        this.sprite && this.sprite.showHideSpriteDom(false);
      }
      this.dataAction = dataAction;

      switch (dataAction) {
        case "future-move":
        case "bpfth":
        case "bpff":
          this.selectWhich = "future";
          this.$nextTick(() => {
            this.hideFourPoints(this.$refs.futureMoveRef, this.sprite);
          });
          if (this.TOOL.adsorb) {
            this.adsorbArr = this.SelectScenes_Msg._getAdsorbArr();
            this.adsorbArr = this.adsorbArr.concat(
              this._getAdsorbData(this.current)
            );
          }
          break;
        case "current-move":
        case "bpfo":
        case "bpft":
          this.selectWhich = "current";
          this.$nextTick(() => {
            this.hideFourPoints(this.$refs.currentMoveRef, this.sprite);
          });
          if (this.TOOL.adsorb) {
            this.adsorbArr = this.SelectScenes_Msg._getAdsorbArr();
            this.adsorbArr = this.adsorbArr.concat(
              this._getAdsorbData(this.future)
            );
          }
          break;
        case "direction-move":
          this.selectWhich = "direction";
          break;
      }
      this.getRotateInfo();
      this.pitchOn = Object.assign({}, this[this.selectWhich]);
      this.mpos = {};
      this.mpos.x = disx.x - this.TOOL.PfixLeft;
      this.mpos.y = disx.y - this.TOOL.PfixTop;
      this.mpos.width = this.pitchOn.width;
      this.mpos.height = this.pitchOn.height;
      this.mpos.minScale =
        20 /
        this.TOOL.scale /
        (this.mpos.width <= this.mpos.height
          ? this.mpos.width
          : this.mpos.height);
      this.mpos.maxScale = (10 * this.TOOL.option.width) / this.mpos.width;
      if (
        this.mpos.maxScale >
        (10 * this.TOOL.option.height) / this.mpos.height
      ) {
        this.mpos.maxScale = (10 * this.TOOL.option.height) / this.mpos.height;
      }
      this.mpos.positionLeft = this.pitchOn.left;
      this.mpos.positionTop = this.pitchOn.top;
      this.mpos.cx = this.pitchOn.left + this.pitchOn.width / 2;
      this.mpos.cy = this.pitchOn.top + this.pitchOn.height / 2;
      this.mpos.rotate = this.pitchOn.rotate;
      // 以下的角度是为了判断顺时针还是逆时针
      this.mpos.deg = this._levelDeg(
        this.mpos.x,
        this.mpos.y,
        this.mpos.cx,
        this.mpos.cy
      );
      this.mpos.mdeg = this.mpos.deg;
      this.mpos.direction = true;
      this.mpos.path = [].concat(this.directionInfo.path);
      this.mpos.box = this._getBBox(this.pitchOn);
      this.mpos.cos = Math.abs(Math.cos((Math.PI / 180) * this.pitchOn.rotate));
      this.mpos.sin = Math.abs(Math.sin((Math.PI / 180) * this.pitchOn.rotate));

      // 为撤销提供数据
      this.mpos.undoData = {
        reData: this.getAllInfo(),
        spriteId: this.sprite.id,
        scenesId: this.sprite.scenesId,
        scale: this.TOOL.scale
      };

      if (this.TOOL.adsorb && dataAction === "spin") {
        this.calcSpinData(this.pitchOn);
      }
    },
    dragMove(pos) {
      // mousemove 事件
      this.isMousemove = true;
      if (!this.sprite) return;
      pos.x -= this.TOOL.PfixLeft;
      pos.y -= this.TOOL.PfixTop;
      let position = {},
        spriteSize = {
          width: 0,
          height: 0
        },
        scaleSize = 0,
        degree = 0,
        adsorb = this.TOOL.adsorb && this.selectWhich !== "direction",
        info = {},
        mpos = this.mpos;

      switch (this.dataAction) {
        case "e":
          // 右
          spriteSize.width = Math.abs(
            mpos.width +
              this._changeLength(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          if (this.selectWhich !== "direction") {
            if (spriteSize.width >= this.TOOL.option.width * 10) {
              spriteSize.width = this.TOOL.option.width * 10;
              break;
            } else if (spriteSize.width <= 20 / this.TOOL.scale) {
              spriteSize.width = 20 / this.TOOL.scale;
              break;
            }
          }
          this.pitchOn.width = spriteSize.width;
          if (
            this.selectWhich !== "direction" &&
            (this.sprite.type === "Text" || this.sprite.type === "RichText")
          ) {
            if (this.pitchOn.width < this.sprite.minWidth) {
              this.pitchOn.width = this.sprite.minWidth;
            }
            this.$refs["currentContent"].children[0].children[0].style.width =
              this.pitchOn.width * this.TOOL.scale + "px";
            this.$refs["futureContent"].children[0].children[0].style.width =
              this.pitchOn.width * this.TOOL.scale + "px";
            this.pitchOn.height =
              this.$refs[this.selectWhich + "Content"].children[0].children[0]
                .scrollHeight / this.TOOL.scale;
          }
          position = this._rotSize(
            this.pitchOn.width,
            this.pitchOn.height,
            mpos.width,
            mpos.height,
            mpos.positionLeft,
            mpos.positionTop,
            mpos.rotate,
            "top-left"
          );
          this.pitchOn.left = position.left;
          this.pitchOn.top = position.top;
          if (
            adsorb &&
            this.sprite.type !== "Text" &&
            this.sprite.type !== "RichText"
          ) {
            this.adsorbData = this._getAdsorbPosPo(
              "non",
              mpos.rotate,
              1,
              this.pitchOn
            );
            info = this._setAdsorbPos(this.adsorbData, "non", mpos);
            if (typeof info.w === "number") {
              this.pitchOn.width = info.w + mpos.width;
              position = this._rotSize(
                this.pitchOn.width,
                this.pitchOn.height,
                mpos.width,
                mpos.height,
                mpos.positionLeft,
                mpos.positionTop,
                mpos.rotate,
                "top-left"
              );
              this.pitchOn.left = position.left;
              this.pitchOn.top = position.top;
            }
          }
          break;
        case "s":
          // 下
          spriteSize.height = Math.abs(
            mpos.height +
              this._changeLength(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          if (spriteSize.height >= this.TOOL.option.height * 10) {
            this.height = this.TOOL.option.height * 10;
            break;
          } else if (spriteSize.height <= 20 / this.TOOL.scale) {
            this.height = 20 / this.TOOL.scale;
            break;
          }
          this.pitchOn.height = spriteSize.height;
          if (
            this.selectWhich !== "direction" &&
            (this.sprite.type === "Text" || this.sprite.type === "RichText")
          ) {
            if (this.pitchOn.height < this.sprite.minWidth) {
              this.pitchOn.height = this.sprite.minWidth;
            }
            this.$refs["currentContent"].children[0].children[0].style.height =
              this.pitchOn.height * this.TOOL.scale + "px";
            this.$refs["futureContent"].children[0].children[0].style.height =
              this.pitchOn.height * this.TOOL.scale + "px";
            this.pitchOn.width =
              this.$refs[this.selectWhich + "Content"].children[0].children[0]
                .scrollWidth / this.TOOL.scale;
          }
          position = this._rotSize(
            this.pitchOn.width,
            this.pitchOn.height,
            mpos.width,
            mpos.height,
            mpos.positionLeft,
            mpos.positionTop,
            this.pitchOn.rotate,
            "top-left"
          );
          this.pitchOn.left = position.left;
          this.pitchOn.top = position.top;
          if (
            adsorb &&
            this.sprite.type !== "Text" &&
            this.sprite.type !== "RichText"
          ) {
            this.adsorbData = this._getAdsorbPosPo(
              "non",
              mpos.rotate,
              2,
              this.pitchOn
            );
            info = this._setAdsorbPos(this.adsorbData, "non", mpos);
            if (typeof info.h === "number") {
              this.pitchOn.height = info.h + mpos.height;
              position = this._rotSize(
                this.pitchOn.width,
                this.pitchOn.height,
                mpos.width,
                mpos.height,
                mpos.positionLeft,
                mpos.positionTop,
                mpos.rotate,
                "top-left"
              );
              this.pitchOn.left = position.left;
              this.pitchOn.top = position.top;
            }
          }
          break;
        case "w":
          // 左
          spriteSize.width = Math.abs(
            mpos.width +
              this._changeLength(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          if (this.selectWhich !== "direction") {
            if (spriteSize.width >= this.TOOL.option.width * 10) {
              spriteSize.width = this.TOOL.option.width * 10;
              break;
            } else if (spriteSize.width <= 20 / this.TOOL.scale) {
              spriteSize.width = 20 / this.TOOL.scale;
              break;
            }
          }
          this.pitchOn.width = spriteSize.width;
          if (
            this.selectWhich !== "direction" &&
            (this.sprite.type === "Text" || this.sprite.type === "RichText")
          ) {
            if (this.pitchOn.width < this.sprite.minWidth) {
              this.pitchOn.width = this.sprite.minWidth;
            }
            this.$refs["currentContent"].children[0].children[0].style.width =
              this.pitchOn.width * this.TOOL.scale + "px";
            this.$refs["futureContent"].children[0].children[0].style.width =
              this.pitchOn.width * this.TOOL.scale + "px";
            this.pitchOn.height =
              this.$refs[this.selectWhich + "Content"].children[0].children[0]
                .scrollHeight / this.TOOL.scale;
          }
          position = this._rotSize(
            this.pitchOn.width,
            this.pitchOn.height,
            mpos.width,
            mpos.height,
            mpos.positionLeft,
            mpos.positionTop,
            this.pitchOn.rotate,
            "top-right"
          );
          this.pitchOn.left = position.left;
          this.pitchOn.top = position.top;
          if (
            adsorb &&
            this.sprite.type !== "Text" &&
            this.sprite.type !== "RichText"
          ) {
            this.adsorbData = this._getAdsorbPosPo(
              "non",
              mpos.rotate,
              3,
              this.pitchOn
            );
            info = this._setAdsorbPos(this.adsorbData, "non", mpos);
            if (typeof info.w === "number") {
              this.pitchOn.width = info.w + mpos.width;
              position = this._rotSize(
                this.pitchOn.width,
                this.pitchOn.height,
                mpos.width,
                mpos.height,
                mpos.positionLeft,
                mpos.positionTop,
                mpos.rotate,
                "top-right"
              );
              this.pitchOn.left = position.left;
              this.pitchOn.top = position.top;
            }
          }
          break;
        case "n":
          // 上
          spriteSize.height = Math.abs(
            mpos.height +
              this._changeLength(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          if (spriteSize.height >= this.TOOL.option.height * 10) {
            this.height = this.TOOL.option.height * 10;
            break;
          } else if (spriteSize.height <= 20 / this.TOOL.scale) {
            this.height = 20 / this.TOOL.scale;
            break;
          }
          this.pitchOn.height = spriteSize.height;
          if (
            this.selectWhich !== "direction" &&
            (this.sprite.type === "Text" || this.sprite.type === "RichText")
          ) {
            if (this.pitchOn.height < this.sprite.minWidth) {
              this.pitchOn.height = this.sprite.minWidth;
            }
            this.$refs["currentContent"].children[0].children[0].style.height =
              this.pitchOn.height * this.TOOL.scale + "px";
            this.$refs["futureContent"].children[0].children[0].style.height =
              this.pitchOn.height * this.TOOL.scale + "px";
            this.pitchOn.width =
              this.$refs[this.selectWhich + "Content"].children[0].children[0]
                .scrollWidth / this.TOOL.scale;
          }
          position = this._rotSize(
            this.pitchOn.width,
            this.pitchOn.height,
            mpos.width,
            mpos.height,
            mpos.positionLeft,
            mpos.positionTop,
            this.pitchOn.rotate,
            "bottom-right"
          );
          this.pitchOn.left = position.left;
          this.pitchOn.top = position.top;
          if (
            adsorb &&
            this.sprite.type !== "Text" &&
            this.sprite.type !== "RichText"
          ) {
            this.adsorbData = this._getAdsorbPosPo(
              "non",
              mpos.rotate,
              0,
              this.pitchOn
            );
            info = this._setAdsorbPos(this.adsorbData, "non", mpos);
            if (typeof info.h === "number") {
              this.pitchOn.height = info.h + mpos.height;
              position = this._rotSize(
                this.pitchOn.width,
                this.pitchOn.height,
                mpos.width,
                mpos.height,
                mpos.positionLeft,
                mpos.positionTop,
                mpos.rotate,
                "bottom-right"
              );
              this.pitchOn.left = position.left;
              this.pitchOn.top = position.top;
            }
          }
          break;
        case "se":
          // 右下
          scaleSize = Math.abs(
            this._scaleSize(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          if (scaleSize <= mpos.minScale) {
            scaleSize = mpos.minScale;
          } else if (scaleSize >= mpos.maxScale) {
            scaleSize = mpos.maxScale;
          }
          this.pitchOn.width = mpos.width * scaleSize;
          this.pitchOn.height = mpos.height * scaleSize;
          position = this._rotSize(
            this.pitchOn.width,
            this.pitchOn.height,
            mpos.width,
            mpos.height,
            mpos.positionLeft,
            mpos.positionTop,
            this.pitchOn.rotate,
            "top-left"
          );
          this.pitchOn.left = position.left;
          this.pitchOn.top = position.top;
          if (adsorb) {
            this.adsorbData = this._getAdsorbPosPo(
              "ratio",
              mpos.rotate,
              1,
              this.pitchOn
            );
            info = this._setAdsorbPos(this.adsorbData, "ratio", mpos);
            if (typeof info.s === "number") {
              info.s = Math.abs(info.s);
              this.pitchOn.width = mpos.width * info.s;
              this.pitchOn.height = mpos.height * info.s;
              position = this._rotSize(
                this.pitchOn.width,
                this.pitchOn.height,
                mpos.width,
                mpos.height,
                mpos.positionLeft,
                mpos.positionTop,
                mpos.rotate,
                "top-left"
              );
              this.pitchOn.left = position.left;
              this.pitchOn.top = position.top;
            }
          }
          break;
        case "sw":
          // 左下
          scaleSize = Math.abs(
            this._scaleSize(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          if (scaleSize <= mpos.minScale) {
            scaleSize = mpos.minScale;
          } else if (scaleSize >= mpos.maxScale) {
            scaleSize = mpos.maxScale;
          }
          this.pitchOn.width = mpos.width * scaleSize;
          this.pitchOn.height = mpos.height * scaleSize;
          position = this._rotSize(
            this.pitchOn.width,
            this.pitchOn.height,
            mpos.width,
            mpos.height,
            mpos.positionLeft,
            mpos.positionTop,
            this.pitchOn.rotate,
            "top-right"
          );
          this.pitchOn.left = position.left;
          this.pitchOn.top = position.top;
          if (adsorb) {
            this.adsorbData = this._getAdsorbPosPo(
              "ratio",
              mpos.rotate,
              2,
              this.pitchOn
            );
            info = this._setAdsorbPos(this.adsorbData, "ratio", mpos);
            if (typeof info.s === "number") {
              info.s = Math.abs(info.s);
              this.pitchOn.width = mpos.width * info.s;
              this.pitchOn.height = mpos.height * info.s;
              position = this._rotSize(
                this.pitchOn.width,
                this.pitchOn.height,
                mpos.width,
                mpos.height,
                mpos.positionLeft,
                mpos.positionTop,
                mpos.rotate,
                "top-right"
              );
              this.pitchOn.left = position.left;
              this.pitchOn.top = position.top;
            }
          }
          break;
        case "nw":
          // 左上
          scaleSize = Math.abs(
            this._scaleSize(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          if (scaleSize <= mpos.minScale) {
            scaleSize = mpos.minScale;
          } else if (scaleSize >= mpos.maxScale) {
            scaleSize = mpos.maxScale;
          }
          this.pitchOn.width = mpos.width * scaleSize;
          this.pitchOn.height = mpos.height * scaleSize;
          position = this._rotSize(
            this.pitchOn.width,
            this.pitchOn.height,
            mpos.width,
            mpos.height,
            mpos.positionLeft,
            mpos.positionTop,
            this.pitchOn.rotate,
            "bottom-right"
          );
          this.pitchOn.left = position.left;
          this.pitchOn.top = position.top;
          if (adsorb) {
            this.adsorbData = this._getAdsorbPosPo(
              "ratio",
              mpos.rotate,
              3,
              this.pitchOn
            );
            info = this._setAdsorbPos(this.adsorbData, "ratio", mpos);
            if (typeof info.s === "number") {
              info.s = Math.abs(info.s);
              this.pitchOn.width = mpos.width * info.s;
              this.pitchOn.height = mpos.height * info.s;
              position = this._rotSize(
                this.pitchOn.width,
                this.pitchOn.height,
                mpos.width,
                mpos.height,
                mpos.positionLeft,
                mpos.positionTop,
                mpos.rotate,
                "bottom-right"
              );
              this.pitchOn.left = position.left;
              this.pitchOn.top = position.top;
            }
          }
          break;
        case "ne":
          // 右上
          scaleSize = Math.abs(
            this._scaleSize(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          if (scaleSize <= mpos.minScale) {
            scaleSize = mpos.minScale;
          } else if (scaleSize >= mpos.maxScale) {
            scaleSize = mpos.maxScale;
          }
          this.pitchOn.width = mpos.width * scaleSize;
          this.pitchOn.height = mpos.height * scaleSize;
          position = this._rotSize(
            this.pitchOn.width,
            this.pitchOn.height,
            mpos.width,
            mpos.height,
            mpos.positionLeft,
            mpos.positionTop,
            this.pitchOn.rotate,
            "bottom-left"
          );
          this.pitchOn.left = position.left;
          this.pitchOn.top = position.top;
          if (adsorb) {
            this.adsorbData = this._getAdsorbPosPo(
              "ratio",
              mpos.rotate,
              0,
              this.pitchOn
            );
            info = this._setAdsorbPos(this.adsorbData, "ratio", mpos);
            if (typeof info.s === "number") {
              info.s = Math.abs(info.s);
              this.pitchOn.width = mpos.width * info.s;
              this.pitchOn.height = mpos.height * info.s;
              position = this._rotSize(
                this.pitchOn.width,
                this.pitchOn.height,
                mpos.width,
                mpos.height,
                mpos.positionLeft,
                mpos.positionTop,
                mpos.rotate,
                "bottom-left"
              );
              this.pitchOn.left = position.left;
              this.pitchOn.top = position.top;
            }
          }
          break;
        case "spin":
          degree = this._levelDeg(pos.x, pos.y, mpos.cx, mpos.cy);
          if (degree >= mpos.mdeg) {
            if (mpos.direction == false) {
              mpos.direction = true;
              mpos.rotate = this.pitchOn.rotate;
              mpos.deg = degree;
            }
          } else {
            if (mpos.direction == true) {
              mpos.direction = false;
              mpos.rotate = this.pitchOn.rotate;
              mpos.deg = degree;
            }
          }
          mpos.mdeg = degree;
          this.pitchOn.rotate = (mpos.rotate + degree - mpos.deg) % 360;
          if (adsorb) {
            var remainder =
              this.pitchOn.rotate - Math.round(this.pitchOn.rotate / 45) * 45;
            if (
              (remainder > 0 && remainder <= 4) ||
              (remainder < 0 && remainder >= -4)
            ) {
              this.pitchOn.rotate = Math.round(this.pitchOn.rotate / 45) * 45;
            }
          }
          break;
        case "future-move":
          this.pitchOn.left = mpos.positionLeft + pos.x - mpos.x;
          this.pitchOn.top = mpos.positionTop + pos.y - mpos.y;
          if (adsorb) {
            this.adsorbData = this._getAdsorbPos(this.pitchOn);
            info = this._setAdsorbPos(this.adsorbData, "move", mpos);
            if (typeof info.x === "number") this.pitchOn.left = info.x;
            if (typeof info.y === "number") this.pitchOn.top = info.y;
          }
          break;
        case "current-move":
          this.pitchOn.left = mpos.positionLeft + pos.x - mpos.x;
          this.pitchOn.top = mpos.positionTop + pos.y - mpos.y;
          if (adsorb) {
            this.adsorbData = this._getAdsorbPos(this.pitchOn);
            info = this._setAdsorbPos(this.adsorbData, "move", mpos);
            if (typeof info.x === "number") this.pitchOn.left = info.x;
            if (typeof info.y === "number") this.pitchOn.top = info.y;
          }
          break;
        case "direction-move":
          this.pitchOn.left = mpos.positionLeft + pos.x - mpos.x;
          this.pitchOn.top = mpos.positionTop + pos.y - mpos.y;
          break;
      }
      if (this.pathType === "Bessel") {
        let changeD = {
          x:
            this.pitchOn.left -
            mpos.positionLeft +
            (this.pitchOn.width - mpos.width) / 2,
          y:
            this.pitchOn.top -
            mpos.positionTop +
            (this.pitchOn.height - mpos.height) / 2,
          x1: pos.x - mpos.x,
          y1: pos.y - mpos.y
        };
        this.changeBessel(
          changeD,
          mpos.path,
          this.selectWhich,
          this.dataAction
        );
      }
      this[this.selectWhich] = Object.assign({}, this.pitchOn);
      if (
        (this.sprite.type === "Text" || this.sprite.type === "RichText") &&
        this.selectWhich !== "direction"
      ) {
        this[
          this.selectWhich === "current" ? "future" : "current"
        ].width = this[this.selectWhich].width;
        this[
          this.selectWhich === "current" ? "future" : "current"
        ].height = this[this.selectWhich].height;
      }
      if (this.selectWhich !== "direction") {
        this.getDirectionInfo(this.selectWhich);
      } else {
        this.fromDirection();
      }
      this.getRotateInfo();
      let partName =
        this.selectWhich === "current"
          ? "currentContent"
          : this.selectWhich === "future"
          ? "futureContent"
          : "";
      partName && this.handleCrop(partName);
    },

    /**
     *
     * @param {String} name 'currentContent' | 'futureContent'
     */
    handleCrop(name) {
      let pathAnimLayer = $("#app .set-pathAnim .current")[0];
      if (!pathAnimLayer) {
        return;
      }
      if (!this.sprite || this.sprite.cropType !== "free") {
        return;
      }
      let cropBoxData = (this.sprite || {}).cropBoxData;
      let moveEl = this.$refs[name];
      if (!moveEl) {
        return;
      }
      let wrapper = $(moveEl.children[0]);
      let image = wrapper.children().eq(0);
      let sprite = this.sprite;

      let nextW = wrapper.width();
      let nextH = wrapper.height();
      var ratioH = nextH / cropBoxData.height;
      var ratioW = nextW / cropBoxData.width;
      var nextCrop = {
        width: nextW,
        height: nextH,
        top: cropBoxData.top * ratioH,
        left: cropBoxData.left * ratioW,
        originWidth: cropBoxData.originWidth * ratioW,
        originHeight: cropBoxData.originHeight * ratioH,
        deltaX: cropBoxData.deltaX * ratioW,
        deltaY: cropBoxData.deltaY * ratioH,
        rotation: cropBoxData.rotation,
        deltaRotation: cropBoxData.deltaRotation,
        innerRotation: cropBoxData.innerRotation
      };

      image.show();
      wrapper.find(".crop-inner-ref").remove();

      wrapper.css({
        position: "relative",
        overflow: "hidden"
      });
      image.css({
        position: "absolute",
        left: nextW / 2 + nextCrop.deltaX - nextCrop.originWidth / 2,
        top: nextH / 2 + nextCrop.deltaY - nextCrop.originHeight / 2,
        width: nextCrop.originWidth,
        height: nextCrop.originHeight,
        maxWidth: nextCrop.originWidth,
        transform: "rotate(" + nextCrop.deltaRotation + "deg)"
      });

      // image.hide();
      // this.setCropContent(nextCrop, wrapper, sprite);
    },
    dragUp() {
      // mouseup事件
      this.calcPosition();

      if (this.TOOL.adsorb) {
        this.spinLine.hide();
        this.netLine.forEach(k => {
          k.hide();
        });
      }

      // 防止没有移动和点击按钮也会触发撤销和update,updateEffect

      if (!this.isMousemove || this.dataAction === "button") {
        this.dataAction = null;
        this.mpos = null;
        return;
      }
      this.isMousemove = false;
      if (this.sprite) {
        if (this.dataAction === "spin") {
          this.setCursor(
            this[this.selectWhich].rotate,
            this.sprite.type,
            this.selectWhich
          );
        }
        // 更新元素本身属性
        this.sprite.update({
          width: this.current.width,
          height: this.current.height,
          positionTop: this.current.top,
          positionLeft: this.current.left,
          rotate: this.current.rotate,
          flip: this.current.flip
        });
        this.sprite.setBorderRadius();
        this.sprite.showHideSpriteDom(false);
        this.updateEffect();
        if (this.mpos) {
          this.mpos.undoData.data = this.getAllInfo();
          eve("undo_redo", null, {
            type: "path_dragPathUp",
            data: this.mpos.undoData
          });
          this.mpos = null;
        }
      }
      if (/bpf/.test(this.dataAction)) this.$analysis(this.ANALYSIS.bpf);
      this.dataAction = null;
    },
    rightClick(dis, action) {
      if (action === "current-move" || action === "future-move") {
        this.$bus.emit("FeaturesPop_vue", {
          type: 1, // 弹窗的类型 1级弹窗 < 2级弹窗
          name: "sprite_right_key",
          sprite: this.sprite,
          posx: dis.x, // 弹窗的定位
          posy: dis.y,
          actionType: "sprite"
        });
      }
    },
    updateEffect(cancelPath) {
      if (cancelPath) {
        // 取消路径动画
        this.sprite.updateEffect({ pathAnim: null }, true);
        this.sprite.syncPathOffset(0, true);
        this.sprite.playSyncContent();
        this.$bus.emit("updateEffect_vue", { type: "noPath" });
        this.dataAction = null;
        this.mpos = null;
        this.isShow = false;
        this.setFreePath = false;
        this.sprite.showHideSpriteDom(true);
        this.sprite = null;
        // this.$bus.emit('change_undo_type', {
        //   type: '',
        //   clearStack: true
        // });

        return;
      }

      this.sprite.updateEffect({ pathAnim: this.getAllInfo(true) });
    },
    getAllInfo: function(pathAnim) {
      // 获取设置路径动画所有的属性
      let data = {};
      data.spriteInfo = {
        width: this.current.width,
        height: this.current.height,
        positionTop: this.current.top,
        positionLeft: this.current.left,
        rotate: this.current.rotate,
        flip: this.current.flip
      };
      data.pathAnim = {
        target: {
          x: this.future.left,
          y: this.future.top,
          rotate: this.future.rotate,
          w: this.future.width,
          h: this.future.height,
          opacity: this.future.opacity,
          fillColor: this.future.fillColor,
          textColor: this.future.textColor
        },
        type: this.pathType,
        info: {
          width: this.direction.width,
          height: this.direction.height,
          rotate: this.direction.rotate,
          top: this.direction.top,
          left: this.direction.left,
          path: this.pathType === "Bessel" ? this.directionInfo.path : null,
          close: this.directionInfo.close || false,
          points: this.directionInfo.points || [],
          freePathType: this.directionInfo.freePathType
        },
        scale: this.TOOL.scale
      };
      if (pathAnim) return data.pathAnim;
      return data;
    },
    calcPosition() {
      // 帮助按钮的位置计算
      if (!this.sprite) return;
      let points,
        calcPoints,
        w = this.Tool_Size.width,
        h = this.Tool_Size.height,
        calcLeft,
        calcTop;

      [points, calcPoints] = this.calcPoint();

      calcPoints.sort((a, b) => {
        return a.y - b.y;
      });

      calcLeft = points[0].x;
      calcTop = calcPoints[0].y - 50;
      // 边界问题
      if (calcLeft + this.TOOL.fixLeft < 0) {
        this.handleInfo.left = 0 - this.TOOL.fixLeft;
      } else if (calcLeft + this.TOOL.fixLeft > w - 170) {
        this.handleInfo.left = w - 85 - this.TOOL.fixLeft;
      } else {
        this.handleInfo.left = calcLeft;
      }

      if (calcTop + this.TOOL.fixTop < 0) {
        calcTop = calcPoints[3].y + 20;
        if (calcTop > h - 76) {
          calcTop = 0 - this.TOOL.fixTop;
        }
        this.handleInfo.top = calcTop;
      } else if (calcTop + this.TOOL.fixTop > h - 76) {
        this.handleInfo.top = h - 130 - this.TOOL.fixTop;
      } else {
        this.handleInfo.top = calcTop;
      }
    },
    calcPoint() {
      let info = {
          left: this[this.selectWhich].left,
          top: this[this.selectWhich].top,
          fixLeft: 0,
          fixTop: 0,
          width: this[this.selectWhich].width,
          height: this[this.selectWhich].height
        },
        rotate = this[this.selectWhich].rotate,
        points = [],
        calcPoints = [];

      // 获取对应的4个点位置
      points[0] = {
        x: info.left + info.fixLeft,
        y: info.top + info.fixTop
      };
      points[1] = {
        x: info.left + info.fixLeft + info.width,
        y: info.top + info.fixTop
      };
      points[2] = {
        x: info.left + info.fixLeft + info.width,
        y: info.top + info.fixTop + info.height
      };
      points[3] = {
        x: info.left + info.fixLeft,
        y: info.top + info.fixTop + info.height
      };
      points[4] = {
        x: info.left + info.fixLeft + info.width / 2,
        y: info.top + info.fixTop + info.height / 2
      };

      calcPoints[0] = this.rotate(points[0], rotate, points[4]);
      calcPoints[1] = this.rotate(points[1], rotate, points[4]);
      calcPoints[2] = this.rotate(points[2], rotate, points[4]);
      calcPoints[3] = this.rotate(points[3], rotate, points[4]);

      return [points, calcPoints];
    },
    rotate(action, data, o) {
      // Angle为正时逆时针转动, 单位为弧度
      data = (Math.PI / 180) * data;
      var b = {};
      b.x =
        (action.x - o.x) * Math.cos(data) -
        (action.y - o.y) * Math.sin(data) +
        o.x;
      b.y =
        (action.x - o.x) * Math.sin(data) +
        (action.y - o.y) * Math.cos(data) +
        o.y;

      return b;
    },
    async doMatting () {
      if(!this.judgeMatting()) {
        // 抠图剩余次数为0
        return;
      }
      let url = this.sprite.option.url;
      let selectWhich = this.selectWhich === 'direction' ? 'future': this.selectWhich;
      // console.log('selectWhich',selectWhich);
      this.matting.isMatting = true;
      this.matting[selectWhich].show = true;
      this.matting[selectWhich].loading = true;
      let res = await this.$http.post(`/api/common/cutout?key=${url}`); // &type=2&faceAnalysis=1
      if (!res.data || res.data.code !== 200) {
        return;
      }
      if (!this.matting.isMatting) {
        return;
      }
      let result = res.data.data;
      let resUrl = result.url;
      this.matting.url = resUrl;
      this.replaceMattingPics('future', selectWhich, resUrl);
      this.replaceMattingPics('current', selectWhich, resUrl);
      sensors.track('doratoonMatting', {
      });
      const {num, use} = result;
      this.$store.commit('toggle_UserMsgCutout', {num, use});
    },
    replaceMattingPics (type,selectWhich, resUrl) {
      let pDom = $(`.${type} .content img`);
      let tUrl = this.$handleAssetsUrl(resUrl);
        pDom.off('load');
        pDom.attr('src', tUrl);
        pDom.on('load', () => {
          this.matting[selectWhich].loading = false;
        });
    },
    actionHandle(e, action) {
      // 帮助按钮的点击事件
      if (!this.sprite) return;

      let data = {};
      data.type = 1;
      data.sprite = this.sprite;
      data.initialX = e.pageX - 280;
      data.initialY = e.pageY;

      switch (action) {
        case "matting":
        this.doMatting();
        break;
        case "delete":
          this.TOOL.removeSprite(this.sprite.id, true);
          break;
        case "cancelPath":
          this.updateEffect(true);
          this.$analysis(this.ANALYSIS.delete);
          break;
        case "setting":
          data.initialX = undefined;
          data.initialY = undefined;
          data.name = "spritePopup";
          this.$bus.emit("FeaturesPop_vue", data);
          break;
        case "setPath":
          this.selectWhich !== "direction" &&
            this.$analysis(this.ANALYSIS[this.selectWhich + "SetPath"]);
          this.selectWhich = "direction";
          this.calcPosition();
          data.initialX =
            this.direction.left +
            this.MaterialPane_Size.width +
            this.TOOL.fixLeft -
            270;
          data.initialY =
            this.direction.top +
            this.TopNav_Size.height +
            this.TOOL.fixTop +
            40;
          data.name = "effectSetting";
          data.contentType = "pathAnim";
          this.$bus.emit("FeaturesPop_vue", data);
          break;
        case "play":
          this.spriteBox = this.sprite;
          this.$bus.emit("preview_callback", {
            type: "play",
            source: "pathAnim",
            startNode: this.sprite.effect.pathAnim.start / 1000,
            stopNode: this.sprite.effect.pathAnim.loop
              ? this.sprite.effect.exitAnim.start / 1000 - 0.02
              : this.sprite.effect.pathAnim.end / 1000 - 0.02,
            spriteBox: this.spriteBox
          });
          this.$analysis(this.ANALYSIS.preview);
          break;
        case "cw":
          this.button.direction[2].action = "ccw";
          this.sprite.updateEffect({
            pathAnim: {
              info: { ccw: 1 }
            }
          });
          this.$analysis(this.ANALYSIS.cw);
          break;
        case "ccw":
          this.button.direction[2].action = "cw";
          this.sprite.updateEffect({
            pathAnim: {
              info: { ccw: 0 }
            }
          });
          this.$analysis(this.ANALYSIS.ccw);
          break;
        case "settingT":
          data.name = "pathTargetSetting";
          this.$bus.emit("FeaturesPop_vue", data);
          break;
        case "swap": {
          const runner = () => {
            let longType = this.getNavType();
            let typeArr = longType.split(".");
            this.$bus.emit("materialPane_vue", {
              type: typeArr[0],
              name: typeArr[1],
              judge: !!typeArr[1]
            });
            this.$store.commit("save_SpriteOperation", "swap");
            // 弹出气泡提示
            this.$bus.emit("blackPopupMsg_showTips", {
              text: "选择左边的素材可进行替换",
              position: {
                top: "186px",
                left: this.MaterialPane_Size.width + 20 + "px"
              }
            });
            this.$analysis(this.ANALYSIS.swap);
          };
          if (this.MaterialNavReady) {
            runner();
          } else {
            this.$bus.emit("materialPane_vue", { type: "props" });
            setTimeout(runner, 500);
          }
          break;
        }
        case "addPic":
        case "editPic":
          eve("helpBtnClicked", null, {
            sprite: this.sprite
          });
          this.sprite.action = "editFrame";
          this.sprite.showHideSpriteDom(true);
          this.isShow = false;
          this.setFreePath = false;
          this.$analysis(this.ANALYSIS[action]);
          break;
        case "editPath":
          this.editFreePath();
          break;
        case "lock":
          this.sprite.setLocked(true);
          this.sprite.showHideHandle(true);
          this.initData();
          break;
        case "favorite":
          (async () => {
            let s = this.SelectSprites_Msg[0];
            let postBody = {
              title: ''
            };
            if(s && s.option.resourceId !== this.favoriteId && this.favoriteStatus === 0) {
              ({
                resourceId: postBody.id,
                fileType: postBody.fileType,
                url: postBody.url,
              } = s.option)
              this.favoriteId = postBody.id;
              this.favoriteStatus = 1;

              let urlArr = postBody.url.split('.');
              let fileType = urlArr.pop();
              let fileName = urlArr.join("");
              let fileTypeLower = fileType.toLowerCase();
              if(!postBody.fileType && fileTypeLower === 'json') {
                postBody.fileType = 5;
              }
              if(!postBody.fileType) {
                this.$message({
                  showClose: true,
                  message: "该类素材不支持收藏",
                  type: "error"
                });
                this.favoriteId = "";
                this.favoriteStatus = 0;
                return;
              }
              this.$message({
                showClose: true,
                message: "正在收藏中...",
              });
              if(fileTypeLower === 'json') {
                fileName = `${fileName}nail.png`;
                if(await this.loadImg(fileName)) {
                  postBody.thumbnailUrl = fileName;
                } else {
                  // 截图上传 (后端处理)
                  let svg = s.ele.children("svg")[0];
                  let width = + svg.getAttribute("width");
                  let height = + svg.getAttribute("height");
                  let blob = new Blob([svg.outerHTML], {type: 'image/svg+xml;charset=utf-8'});
                  let blobUrl = URL.createObjectURL(blob);
                  let img = await this.loadImg(blobUrl, true);
                  if(img) {
                    let canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    let ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
                    blob = await new Promise(resolve => {
                      canvas.toBlob(resolve)
                    })
                    let formData = new FormData();
                    formData.append("lottieThumb", blob);
                    let res = await this.$http({
                      url: "/api/upload/file",
                      method: "post",
                      data: formData,
                      dataType: "json",
                      Headers: {
                        "Content-Type": "multipart/form-data; boundary=---12321"
                      }
                    }).catch(() => {
                      return null
                    })
                    if(res && res.data && res.data.data) {
                      postBody.thumbnailUrl = res.data.data.filename || '';
                    }
                  }
                }
              } else if(fileTypeLower === 'svg') {
                fileName = `${fileName}.png`;
                if(await this.loadImg(fileName)) {
                  postBody.thumbnailUrl = fileName;
                } else {
                  postBody.thumbnailUrl = postBody.url;
                }
              } else {
                fileName = `${fileName}nail.${fileType}`;
                if(await this.loadImg(fileName)) {
                  postBody.thumbnailUrl = fileName;
                } else {
                  postBody.thumbnailUrl = postBody.url;
                }
              }
              this.$http.post("/api/user/favorites", postBody).then(res => {
                this.favoriteStatus = 0;
                this.favoriteId = "";
                if(res.status === 200) {
                  if(res.data.code === 200) {
                    let fType = '';
                    if(res.data.data) {
                      if(res.data.data.returnId && !postBody.id) {
                        s.option.resourceId = res.data.data.returnId;
                      }
                      if(res.data.data.newTable) {
                        switch(res.data.data.newTable) {
                          case "PROP":
                            fType = "props";
                            break;
                          case "CHARACTERS":
                            fType = "characters";
                            break;
                          case "MUSIC":
                            fType = "music";
                            break;
                          case "SHAPE":
                            fType = "shapes";
                            break;
                          case "TEXT":
                            fType = "text";
                            break;
                          case "GIF":
                            fType = "gif";
                            break;
                          case "BG":
                            fType = "bg";
                            break;
                        }
                      }
                    }
                    if(res.data.data && !postBody.id) {
                      s.option.resourceId = res.data.data;
                    }
                    this.$message({
                      showClose: true,
                      message: '收藏成功',
                    });
                    // 最新的收藏事件
                    this.$bus.emit('open-resource-area', this.fileTypeToType(+postBody.fileType));
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.data.msg,
                      type: "error"
                    });
                  }
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: "error"
                  });
                }
              })
            } else {
              this.$message({
                showClose: true,
                message: "收藏太频繁，请稍等重试",
              });
            }
          })()
          break;
      }
    },
    emitText() {
      if (this.sprite.type === "Text") {
        this.$bus.emit("updateText", this.sprite);
        this.isShow = false;
        this.setFreePath = false;
      } else if (this.sprite.type === "RichText") {
        eve("editor.richTextEdit", null, this.sprite);
        this.isShow = false;
        this.setFreePath = false;
      }
    },
    setCursor(deg, type, selectWhich) {
      let showClassArr = [],
        sliceIndex = 0;

      if (deg < -22.5) {
        deg = deg + 360;
      } else if (deg > 347.5) {
        deg = deg - 360;
      }

      // 每隔45° 数组变化一次，将第一个数据放入到最后
      sliceIndex = parseInt((deg + 22.5) / 45);
      showClassArr = this.cursorArr
        .slice(sliceIndex)
        .concat(this.cursorArr.slice(0, sliceIndex));

      if (this[selectWhich + "Point"].length === 3) {
        for (var i = 0; i < this[selectWhich + "Point"].length - 1; i++) {
          this[selectWhich + "Point"][i].pt.cursor =
            showClassArr[
              i * 4 + (this.sprite.versionAnyway === "Vertical" ? 0 : 2)
            ];
        }
      } else if (this[selectWhich + "Point"].length === 5) {
        for (var i = 0; i < this[selectWhich + "Point"].length - 1; i++) {
          this[selectWhich + "Point"][i].pt.cursor = showClassArr[i * 2 + 1];
        }
      } else {
        for (var i = 0; i < this[selectWhich + "Point"].length - 1; i++) {
          this[selectWhich + "Point"][i].pt.cursor = showClassArr[i];
        }
      }
    },
    changeSvgStyle(dom, option, sprite) {
      sprite = sprite || this.sprite;
      let svg = dom.querySelector("svg");
      let nodeList = [].slice.call(svg.querySelectorAll("*"), 1);
      nodeList.forEach(el => {
        let $el = $(el);
        if (option.fill) {
          let attrFill = $el.css("fill");
          let isUrlFill = false;
          if (sprite) {
            isUrlFill = sprite.isUrlFill(attrFill);
          }
          if (
            attrFill &&
            attrFill !== "none" &&
            attrFill !== "transparent" &&
            el.tagName != "defs" &&
            el.tagName != "style" &&
            !isUrlFill
          ) {
            el.setAttribute("fill", option.fill);
            $el.css("fill", option.fill);
            $el.css("stop-color", option.fill);
          }
        } else if (option.stroke) {
          let attrStroke = $el.css("stroke");
          if (
            attrStroke &&
            attrStroke !== "none" &&
            attrStroke !== "transparent"
          ) {
            $el.css("stroke", option.stroke);
          }
        } else if (option.strokeWidth) {
          // $el.css('strokeWidth', option.strokeWidth* Math.max(
          //   1,
          //   svg.viewBox.animVal.width/svg.width.animVal.value, svg.viewBox.animVal.height/svg.width.animVal.value
          // ));

          $el.css(
            "strokeWidth",
            ((option.strokeWidth *
              Math.min(
                svg.viewBox.animVal.width / svg.width.animVal.value,
                svg.viewBox.animVal.height / svg.height.animVal.value
              )) /
              this.TOOL.scale) *
              1.626
          );
        }
      });
    },
    _getBBox(info) {
      let r = (Math.PI / 180) * info.rotate,
        t = {
          cos: Math.abs(Math.cos(r)),
          sin: Math.abs(Math.sin(r))
        },
        box = {
          w: info.width * t.cos + info.height * t.sin,
          h: info.width * t.sin + info.height * t.cos,
          cx: info.left + info.width / 2,
          cy: info.top + info.height / 2
        };
      box.t = box.cy - box.h / 2;
      box.b = box.cy + box.h / 2;
      box.l = box.cx - box.w / 2;
      box.r = box.cx + box.w / 2;
      return box;
    },
    _getAdsorbData(info) {
      // 获取外接矩形的信息
      let box = this._getBBox(info);
      // 分别是top, right, bottom, left, centerY, chenterX
      return [box.t, box.r, box.b, box.l, box.cy, box.cx];
    },
    _getAdsorbPos(info) {
      let adsorb = this._getAdsorbData(info),
        adsorbArr = this.adsorbArr,
        arr = [[], []],
        data = [{}, {}, {}, {}, {}, {}];

      for (let i in adsorbArr) {
        arr[i % 2].push(adsorbArr[i]);
      }

      for (let j in adsorb) {
        let index = j % 2;
        for (let k in arr[index]) {
          if (Math.abs(adsorb[j] - arr[index][k]) <= 5) {
            data[j].k = adsorb[j];
            data[j].v = arr[index][k];
            data[j].arr = adsorb;
          }
        }
      }
      this.showNetLine(data);
      return data;
    },
    _getAdsorbPosPo(action, deg, start, info) {
      // 缩放吸附位置计算（0上，1右，2下，3左，4中，5竖）
      let adsorb = this._getAdsorbData(info),
        adsorbArr = this.adsorbArr,
        step = (deg > 0 ? deg : 360 + deg) / 90,
        arr = [[], []],
        data = [{}, {}, {}, {}, {}, {}],
        need = {
          // 应该吸附的对应位置
          ratio: [],
          non: []
        };

      for (var i in adsorbArr) {
        arr[i % 2].push(adsorbArr[i]);
      }

      // 每隔90度需要吸附的对应边会变1
      if (step - Math.floor(step)) {
        step = Math.floor(step);
        start = (start + step) % 4;
        need.non[0] = start;
        start = (start + 1) % 4;
        need.ratio[0] = start;
        need.non[1] = start;
      } else {
        start = (start + step) % 4;
        need.ratio[0] = start;
        need.non[0] = start;
        start = (start + 1) % 4;
        need.ratio[1] = start;
      }

      for (var j in adsorb) {
        // 判断是否需要对应边是否需要吸附
        if (j != need[action][0] && j != need[action][1]) continue;
        var index = j % 2;
        for (var k in arr[index]) {
          if (Math.abs(adsorb[j] - arr[index][k]) <= 5) {
            data[j].k = adsorb[j];
            data[j].v = arr[index][k];
            data[j].arr = adsorb;
          }
        }
      }
      this.showNetLine(data);
      return data;
    },
    _setAdsorbPos(data, action, mpos) {
      var info = {},
        b = mpos.box;
      if (action === "move") {
        data.forEach((v, i) => {
          if (v.v) {
            if (i % 2 === 0) {
              info.y = v.v - v.arr[i] + v.arr[4] - mpos.height / 2;
            } else {
              info.x = v.v - v.arr[i] + v.arr[5] - mpos.width / 2;
            }
          }
        });
      } else if (action === "ratio") {
        data.forEach((v, i) => {
          if (v.v) {
            if (i === 0) info.s = (v.v - b.b) / b.h;
            if (i === 1) info.s = (v.v - b.l) / b.w;
            if (i === 2) info.s = (v.v - b.t) / b.h;
            if (i === 3) info.s = (v.v - b.r) / b.w;
          }
        });
      } else if (action === "non") {
        data.forEach((v, i) => {
          if (v.v) {
            if (i === 0) {
              info.w = (b.t - v.v) / mpos.sin;
              info.h = (b.t - v.v) / mpos.cos;
            } else if (i === 1) {
              info.w = (v.v - b.r) / mpos.cos;
              info.h = (v.v - b.r) / mpos.sin;
            } else if (i === 2) {
              info.w = (v.v - b.b) / mpos.sin;
              info.h = (v.v - b.b) / mpos.cos;
            } else if (i === 3) {
              info.w = (b.l - v.v) / mpos.cos;
              info.h = (b.l - v.v) / mpos.sin;
            }
          }
        });
      }
      return info;
    },
    createDomBox() {
      this.auxiliary = $("#handle_auxiliary_path_line_box");
      this.createSpinLine();
      this.createNetLine();
    },
    createSpinLine() {
      this.spinLine = $('<div id="auxiliary_path_line_spin_box"></div>')
        .append([
          $('<div class="spin_line_level"></div>'),
          $('<div class="spin_line_vertical"></div>'),
          $('<div class="spin_line_tile"></div>'),
          $('<div class="spin_line_tile_t"></div>')
        ])
        .appendTo(this.auxiliary)
        .hide();
    },
    createNetLine() {
      this.netLine = [
        $('<div class="net_line_top"></div>').hide(),
        $('<div class="net_line_right"></div>').hide(),
        $('<div class="net_line_bottom"></div>').hide(),
        $('<div class="net_line_left"></div>').hide(),
        $('<div class="net_line_middle"></div>').hide(),
        $('<div class="net_line_center"></div>').hide()
      ];
      $('<div id="auxiliary_path_line_net_box"></div>')
        .append(this.netLine)
        .appendTo(this.auxiliary);
    },
    calcSpinData(content) {
      if (!this.TOOL.adsorb) {
        this.spinLine.hide();
        return;
      }
      this.spinLineData.width = this.spinLineData.height =
        Math.max(content.width, content.height) * 1.6;
      this.spinLineData.top =
        content.top - (this.spinLineData.height - content.height) / 2;
      this.spinLineData.left =
        content.left - (this.spinLineData.width - content.width) / 2;
      this.spinLine.css(this.spinLineData).show();
    },
    showNetLine(arr) {
      // 显示元素变化时的辅助线
      arr.forEach((val, i) => {
        if (val.v) {
          if ((i + 2) % 2 === 0) {
            this.netLine[i]
              .css({
                top: val.v
              })
              .show();
          } else {
            this.netLine[i]
              .css({
                left: val.v
              })
              .show();
          }
        } else {
          this.netLine[i].hide();
        }
      });
    },
    changeBessel(change, path, witch, act) {
      let cp = [].concat(path),
        info = null,
        pathStr = "";
      if (act === "bpfo") {
        cp[2] += change.x1;
        cp[3] += change.y1;
      } else if (act === "bpft") {
        cp[2] -= change.x1;
        cp[3] -= change.y1;
      } else if (act === "bpfth") {
        cp[4] -= change.x1;
        cp[5] -= change.y1;
      } else if (act === "bpff") {
        cp[4] += change.x1;
        cp[5] += change.y1;
      } else {
        if (witch === "current") {
          cp[0] += change.x;
          cp[1] += change.y;
          cp[2] += change.x;
          cp[3] += change.y;
        } else if (witch === "future") {
          cp[4] += change.x;
          cp[5] += change.y;
          cp[6] += change.x;
          cp[7] += change.y;
        } else {
          return;
        }
      }
      cp.splice(2, 0, "C");
      pathStr = "M" + cp.join(" ");
      info = this.svgDom
        .first()
        .attr({
          d: pathStr
        })
        .bbox();
      this.direction.width = info.w;
      this.direction.height = info.h;
      this.svgDom.size(info.w, info.h);
      cp.splice(2, 1);
      for (let i in cp) {
        cp[i] -= i % 2 ? info.y : info.x;
      }
      cp.splice(2, 0, "C");
      pathStr = "M" + cp.join(" ");
      this.svgDom.first().attr({
        d: pathStr
      });
      cp.splice(2, 1);
      this.directionInfo.path = [].concat(cp);
    },
    _getPath(point, type, close) {
      let path = "";
      if (type === "line") {
        point.forEach((e, i) => {
          if (i === 0) {
            path = `M ${e[2]} ${e[3]}`;
          } else {
            path += ` ${e[2]} ${e[3]}`;
          }
        });
        if (close && point.length > 2) {
          path += ` ${point[0][2]} ${point[0][3]} Z`;
        }
      } else {
        point.forEach((e, i) => {
          if (i === 0) {
            path = `M ${e[2]} ${e[3]}`;
          } else {
            path += ` C ${point[i - 1][4]} ${point[i - 1][5]} ${e[0]} ${e[1]} ${
              e[2]
            } ${e[3]}`;
          }
        });
        if (close) {
          path += ` C ${point[point.length - 1][4]} ${
            point[point.length - 1][5]
          } ${point[0][0]} ${point[0][1]} ${point[0][2]} ${point[0][3]} Z`;
        }
      }
      return path;
    },
    editFreePath() {
      if (this.pathType === "FreePath") {
        this.$bus.emit("set_path_anim", { action: "edit" });
        eve("undo_redo", null, {
          type: "path_dbToEdit",
          data: {
            spriteId: this.sprite.id,
            scenesId: this.sprite.scenesId
          }
        });
      }
    },
    async loadImg(url, blob) {
      let imgPro = new Promise((resolve) => {
        let img = new Image();
        img.onload = () => {
          resolve(img);
        };
        img.onerror = () => {
          resolve(false);
        };
        setTimeout(() => {
          resolve(false);
        }, 800)
        if(blob) {
          img.src = url
        } else {
          img.src = this.$handleAssetsUrl(url);
        }
      });

      return await imgPro;
    },
    fileTypeToType(fileType) {
      let type = '';
      let index = -1;
      //	3：背景 14: 人物，15: 形状，16：文字，17：道具 36:gif
      // 没有对应 4: 图片 5：音乐 8：模板
      // 视频没有对应（ 收藏没有视频 1：视频，）
      switch(fileType) {
        case 1:
        case 2:
        case 25:
          type = 'bg' // 3 背景
          index = 2
          break;
        case 3:
        case 4:
        case 5:
        case 22:
        case 35:
        case 42:
        case 46:
        // 图片都归为道具
        case 18:
        case 19:
        case 34:
        case 47:
          type = 'props' // 17 道具
          index = 5
          break;
        case 10:
          type = 'characters' // 14
          index = 4
          break;
        case 6:
        case 7:
        case 8:
        case 9:
        case 23:
        case 28:
        case 29:
        case 33:
        case 30:
          type = 'shapes' // 15 形状
          index = 5
          break;
        case 11:
        case 12:
        case 13:
          type = 'text' // 16 文字
          index = 3
          break;
        case 32:
          type = 'gif' // 37 gif
          index = 5
          break;
      }
      return { type, index }
    }
  }
};
</script>

<style lang="scss" scoped>
.set-pathAnim {
  position: absolute;
  z-index: 125;
  background-color: rgba(255, 255, 255, 0.5);

  * {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    box-sizing: border-box;
  }

  .cancel-path {
    position: absolute;
    width: 26px;
    height: 24px;
    background: url("../../../static/svg/scissor.svg");
    z-index: 30;
    cursor: pointer;
  }

  .rotate-info {
    position: absolute;
    width: 30px;
    height: 30px;
    line-height: 28px;
    color: #fff;
    font-size: 11px;
    border: 1px solid #fff;
    border-radius: 50%;
    user-select: none;
    background: rgba(0, 0, 0, 0.5);
    z-index: 15;
  }

  .current,
  .future,
  .direction {
    position: absolute;
    display: flex;

    .content {
      position: relative;
      width: 100%;
      height: 100%;
      line-height: normal;
    }
  }

  .direction {
    position: absolute;

    #directionSVG {
      display: flex;
      width: 100%;
      height: 100%;
      position: relative;
      top: 0;
      left: 0;
    }
  }

  .current-help,
  .future-help,
  .direction-help {
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    z-index: 20;

    &:not(.active) {
      > div {
        display: none;
      }
    }
    &.active {
      z-index: 100;
    }

    &:hover,
    &.active {
      border: 1px dashed #37484f;
    }
  }
  .direction-help {
    z-index: 15;

    .op-handle-point {
      background-color: #5778fb;
    }

    .op-handle-spin {
      background: url("../../../static/svg/rotate-blue.svg");
    }
    &:hover,
    &.active {
      border: 1px dashed #5778fb;
    }
  }
  .handle-button {
    position: absolute;
    display: flex;
    border: 2px solid white;
    border-radius: 6px;
    background: white;
    z-index: 125;

    .op-handle-setting,
    .op-handle-settingT {
      background-image: url("../../../static/svg/setting.svg");

      &:hover {
        background-image: url("../../../static/svg/setting-active.svg");
      }
    }
    .op-handle-matting {
      background-image: url("../../../static/svg/matting.svg");

      &:hover {
        background-image: url("../../../static/svg/matting-active.svg");
      }
    }

    .op-handle-delete {
      background-image: url("../../../static/svg/delete.svg");

      &:hover {
        background-image: url("../../../static/svg/delete-active.svg");
      }
    }
    .op-handle-play {
      background-size: 25px 25px;
      background-image: url("../../../static/svg/path-play.svg");

      &:hover {
        background-image: url("../../../static/svg/path-play-active.svg");
      }
    }
    .op-handle-setPath {
      background-size: 25px 25px;
      background-image: url("../../../static/svg/path-setting.svg");

      &:hover {
        background-image: url("../../../static/svg/path-setting-active.svg");
      }
    }
    .op-handle-cancelPath {
      background-size: 25px 25px;
      background-image: url("../../../static/svg/cancel-path.svg");

      &:hover {
        background-image: url("../../../static/svg/cancel-path-active.svg");
      }
    }
    .op-handle-ccw {
      background-size: 25px 25px;
      background-image: url("../../../static/svg/CCW.svg");

      &:hover {
        background-image: url("../../../static/svg/CCW-active.svg");
      }
    }
    .op-handle-cw {
      background-size: 25px 25px;
      background-image: url("../../../static/svg/CW.svg");

      &:hover {
        background-image: url("../../../static/svg/CW-active.svg");
      }
    }
    .op-handle-swap {
      background-image: url("../../../static/svg/replace.svg");

      &:hover {
        background-image: url("../../../static/svg/replace-active.svg");
      }
    }
    .op-handle-editPic {
      background-image: url("../../../static/svg/pen-active.svg");

      &:hover {
        background-image: url("../../../static/svg/pen.svg");
      }
    }
    .op-handle-addPic {
      background-image: url("../../../static/svg/add-pic-active.svg");

      &:hover {
        background-image: url("../../../static/svg/add-pic.svg");
      }
    }
    .op-handle-editPath {
      background-image: url("../../../static/svg/edit-path-active.svg");

      &:hover {
        background-image: url("../../../static/svg/edit-path.svg");
      }
    }
    .op-handle-lock {
      background-image: url("../../../static/svg/lock.svg");

      &:hover {
        background-image: url("../../../static/svg/lock-active.svg");
      }
    }
    .op-handle-favorite{
      background-image: url("../../../static/svg/favorite.svg");

      &:hover {
        background-image: url("../../../static/svg/favorite-active.svg");
      }
    }
  }
}

.begin-circle {
  position: absolute;
  top: -7px;
  left: -7px;
  width: 15px;
  height: 15px;
  border: 2px solid #424f61;
  border-radius: 50%;
  background: #fff;
}

.end-triangle {
  position: absolute;
  top: 44%;
  left: -6px;
  width: 15px;
  height: 24px;

  &::before {
    position: absolute;
    top: 0;
    left: 2px;
    border: solid transparent;
    border-width: 5px;
    border-bottom-color: #fff;
    border-bottom-width: 13px;
    content: " ";
    z-index: 5;
  }

  &::after {
    border: solid transparent;
    border-width: 10px;
    border-bottom-color: #424f61;
    border-bottom-width: 21px;
    content: " ";
    position: absolute;
    top: -10px;
    left: -3px;
  }
}

.bessel-box {
  position: absolute;
  top: 0;
  left: 0;
  height: 0px;
  width: 0px;
  z-index: 200;

  > div {
    position: absolute;
    width: 100px;
    height: 1px;
    background-color: #fe1bfd;

    > div {
      position: absolute;
      top: -6px;
      width: 13px;
      height: 13px;
      border: 2px solid #fe1bfd;
      border-radius: 50%;
      background: #fff;
    }
  }

  .bessel-one,
  .bessel-three {
    left: -6px;
  }

  .bessel-two,
  .bessel-four {
    right: -6px;
  }
}
</style>
<style lang="scss">
// 加上scoped后不会生效，因为html不属于当前组件了可能
.text-clip {
  -webkit-background-clip: text;
  background-clip: text;
}

// 对应图片裁剪
.future .content > div,
.current .content > div {
  overflow: hidden;
}

#handle_auxiliary_path_line_box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  box-sizing: border-box;
}
#auxiliary_path_line_spin_box {
  position: absolute;
  top: 0;
  left: 0;

  .spin_line_level,
  .spin_line_vertical,
  .spin_line_tile,
  .spin_line_tile_t {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 100%;
    border-top: 1px solid #fff;
    transform-origin: center top;
    opacity: 0.8;

    &::before {
      position: absolute;
      display: block;
      content: "";
      border-top: 1px dashed #00ffff;
      height: 100%;
      width: 100%;
      margin: -1px;
      box-sizing: content-box;
      pointer-events: none;
    }
  }
  .spin_line_vertical {
    transform: rotate(90deg);
  }
  .spin_line_tile {
    transform: rotate(45deg);
  }
  .spin_line_tile_t {
    transform: rotate(-45deg);
  }
}

#auxiliary_path_line_net_box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  div {
    position: absolute;
    opacity: 0.6;
  }

  div:nth-child(even) {
    height: 100%;
    width: 1px;
    border-left: 1px solid #fff;

    &::before {
      position: absolute;
      display: block;
      content: "";
      border-left: 1px dashed #00ffff;
      height: 100%;
      width: 1px;
      left: -1px;
      box-sizing: content-box;
      pointer-events: none;
    }
  }
  div:nth-child(odd) {
    width: 100%;
    height: 1px;
    border-top: 1px solid #fff;

    &::before {
      position: absolute;
      display: block;
      content: "";
      border-top: 1px dashed #00ffff;
      height: 1px;
      width: 100%;
      top: -1px;
      box-sizing: content-box;
      pointer-events: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/setPathAnim.vue